const DataType = {
  GrantTypeEnum: {
    EMPLOYEE: { value: 88010101, text: 'EMPLOYEE' },
    CUSTOMER: { value: 88010102, text: 'CUSTOMER' }
  },
  WithdrawnReason: {
    20000: 'Account closed',
    20001: 'Bad Employment/Position',
    20002: 'Bad State/ZIP Code',
    20003: 'Customer is in collections',
    20004: 'Customer is not the bk acct holder',
    20005: 'Customer is self-employed',
    20006: 'Customer has Garnishment',
    20007: 'Customer has liquid, savings or business account',
    20008: 'Customer requested not to be called againDNC)',
    20009: 'Customer is deceased',
    20010: 'FRAUD',
    20011: 'Incorrect Social Security Number',
    20012: 'Military',
    20013: 'DAP denied',
    20014: 'Customer failed to answer the authentication/security questions',
    20015: 'Customer has holds, freezes, restrictions, stop payments or TCA in the last 90 days',
    20016: 'Unable to do VOB or VOE',
    20017: 'Special Case',
    20018: 'Tribe Denied',
    20019: 'Customer is in Portfolio Collections',
    20020: 'Customer is in External Collections',
    20021: 'Denied by Tribe - Elevated concern',
    20022: 'Denied by Tribe - General guidelines',
    20023: 'Customer is Unemployed',
    20024: 'Customer is in Collections - No Call Attempt made',
    // 10000: 'Customer is no longer interested',
    10001: 'Application Timeout',
    10002: 'Bad Bank/Bad ABA',
    10003: 'Bad Contact Info',
    10004: 'Duplicate lead',
    10006: 'Customer does not meet the minimum required age',
    10007: 'Customer has no DDs',
    10008: 'Not qualified as per loan matrix',
    10009: 'Customer has open loan with another CO',
    10010: 'Prepaid card / Debit card',
    10011: 'Language Barriernot Spanish nor English).',
    10012: 'Unable to complete correction, customer is unreachable for more than 2 days',
    10013: 'Unpredictable/Incorrect Payroll FrequencyMonthly, Daily, Semi-monthly, Weekend)',
    10014: 'MinimumIncomeNotMet',
    10015: 'UnableVerBankInfo',
    10016: 'PaperCheck',
    10017: 'FactorTrustFailed',
    10018: 'VeritecFailed',
    10019: 'AutoWithdrawn',
    10020: 'Other',
    10021: 'AmountIsTooLow',
    10022: 'Non-Standard Source of Income',
    10023: 'No Enough Deposits',
    10024: 'Customer is no longer interested - Amount too low',
    10025: 'Customer is no longer interested - Payments too high',
    10026: 'Customer is no longer interested - High Interest or ARR',
    10027: 'Customer is no longer interested - Does not want to complete loan process',
    10028: 'Customer is no longer interested - Needs the funds sooner',
    10029: 'Customer is no longer interested - Already got another loan',
    10030: 'Customer is no longer interested - Does not agree with the repayment schedule',
    10031: 'No Business State'
  },

  PaymentSpecialTypeEnum: {
    VOIDED: { value: 10001, text: 'Voided' },
    CORRECTION_CODE: { value: 10002, text: 'Correction Code' },
    WRONG_DATA: { value: 10003, text: 'Wrong Data' },
    MISSED_DATA: { value: 10004, text: 'Missed Date' },
    COLLECTION_REJECTED: { value: 10005, text: 'Collection Rejected' },
    REFUND_REJECT: { value: 10006, text: 'Refund Reject' },
    REFUSE_DATA: { value: 10007, text: 'Refuse Data' },
    OVERFLOW: { value: 10008, text: 'Overflow' },
    INVALID_DELAY_TRANSACTION: { value: 10009, text: 'Invalid Delay Transaction' }
  },

  WithdrawCodeEnum: {
    // indexOf('1') === 0 => Positive else Negative
    ACCOUNT_CLOSED: { value: 20000, text: 'Account closed' },
    BAD_EMPLOYMENT_POSITION: { value: 20001, text: 'Bad Employment/Position' },
    // BAD_STATE_ZIP_CODE: { value: 20002, text: 'Bad State/ZIP Code' },
    // CUSTOMER_IS_IN_COLLECTIONS: { value: 20003, text: 'Customer is in collections' },
    CUSTOMER_IS_NOT_THE_BK_ACCT_HOLDER: { value: 20004, text: 'Customer is not the bk acct holder' },
    CUSTOMER_IS_SELF_EMPLOYED: { value: 20005, text: 'Customer is self-employed' },
    CUSTOMER_HAS_GARNISHMENT: { value: 20006, text: 'Customer has Garnishment' },
    CUSTOMER_HAS_LIQUID_SAVINGS_OR_BUSINESS_ACCOUNT: {
      value: 20007,
      text: 'Customer has liquid, savings or business account'
    },
    CUSTOMER_REQUESTED_NOT_TO_BE_CALLED_AGAIN: { value: 20008, text: 'Customer requested not to be called again (DNC)' },
    CUSTOMER_IS_DECEASED: { value: 20009, text: 'Customer is deceased' },
    FRAUD: { value: 20010, text: 'Fraud' },
    INCORRECT_SOCIAL_SECURITY_NUMBER: { value: 20011, text: 'Incorrect Social Security Number' },
    MILITARY: { value: 20012, text: 'Military' },
    DAP_DENIED: { value: 20013, text: 'DAP denied' },
    CUSTOMER_FAILED_TO_ANSWER_THE_AUTHENTICATION_SECURITY_QUESTIONS: {
      value: 20014,
      text: 'Customer failed to answer the authentication/security questions'
    },
    CUSTOMER_HAS_HOLDS_FREEZES_RESTRICTIONS_STOP_PAYMENTS_OR_TCA_IN_THE_LAST_90_DAYS: {
      value: 20015,
      text: 'Customer has holds, freezes, restrictions, stop payments or TCA in the last 90 days'
    },
    UNABLE_TO_DO_VOB_OR_VOE: { value: 20016, text: 'Unable to do VOB or VOE' },
    SPECIAL_CASE: { value: 20017, text: 'Special Case' },
    CUSTOMER_IS_IN_PORTFOLIO_COLLECTIONS: { value: 20019, text: 'Customer is in Portfolio Collections' },
    CUSTOMER_IS_IN_EXTERNAL_COLLECTIONS: { value: 20020, text: 'Customer is in External Collections' },
    CUSTOMER_IS_UNEMPLOYED: { value: 20023, text: 'Customer is Unemployed' },
    CUSTOMER_IS_IN_COLLECTION_NO_CALL_ATTEMPT_MADE: { value: 20024, text: 'Customer is in Collections - No Call Attempt made' },
    NBS: { value: 20025, text: 'NBS' },
    // CUSTOMER_IS_NO_LONGER_INTERESTED: { value: 10000, text: 'Customer is no longer interested' },
    // AUTO_WITHDRAWN_DUE_TO_LOAN_AGE: { value: 10001, text: 'Auto withdrawn due to loan age' },
    BAD_BANK_BAD_ABA: { value: 10002, text: 'Bad Bank/Bad ABA' },
    BAD_CONTACT_INFO: { value: 10003, text: 'Bad Contact Info' },
    DUPLICATE_LEAD: { value: 10004, text: 'Duplicate lead' },
    // DOES_NOT_QUALIFY: { value: 10005, text: 'Does not qualify' },
    CUSTOMER_DOES_NOT_MEET_THE_MINIMUM_REQUIRED_AGE: {
      value: 10006,
      text: 'Customer does not meet the minimum required age'
    },
    CUSTOMER_HAS_NO_DDS: { value: 10007, text: 'Customer has no DDs' },
    NOT_QUALIFIED_AS_PER_LOAN_MATRIX: { value: 10008, text: 'Not qualified as per loan matrix' },
    CUSTOMER_HAS_OPEN_LOAN_WITH_ANOTHER_CO: { value: 10009, text: 'Customer has open loan with another CO' },
    PREPAID_CARD_DEBIT_CARD: { value: 10010, text: 'Prepaid card / Debit card' },
    LANGUAGE_BARRIER: { value: 10011, text: 'Language Barrier (not Spanish nor English)' },
    UNABLE_TO_COMPLETE_CORRECTION_CUSTOMER_IS_UNREACHABLE_FOR_MORE_THAN_2_DAYS: {
      value: 10012,
      text: 'Unable to complete correction, customer is unreachable for more than 2 days'
    },
    UNPREDICTABLE_INCORRECT_PAYROLL_FREQUENCY: {
      value: 10013,
      text: 'Unpredictable/Incorrect Payroll Frequency (Monthly, Daily, Semi-monthly, Weekend)'
    },
    // MINIMUM_INCOME_NOT_NET: { value: 10014, text: 'Minimum income not met' },
    // UNABLE_VER_BANK_INFORMATION: { value: 10015, text: 'Unable ver bank info' },
    // PAPER_CHECK: { value: 10016, text: 'Paper Check' },
    // FACTOR_TRUST_FAILED: { value: 10017, text: 'Factor trust failed' },
    // VERIFY_FAILED: { value: 10018, text: 'Verify failed' },
    // AUTO_WITHDRAWN: { value: 10019, text: 'Auto withdrawn' },
    // OTHER: { value: 10020, text: 'Other' },
    // AMOUNT_IS_TOO_LOW: { value: 10021, text: 'Amount is too low' },
    NON_STANDARD_SOURCE_INCOME: { value: 10022, text: 'Non-Standard Source of Income' },
    NED: { value: 10023, text: 'NED' },
    AMOUNT_TO_LOW: { value: 10024, text: 'Customer is no longer interested - Amount too low' },
    PAYMENTS_TOO_HIGH: { value: 10025, text: 'Customer is no longer interested - Payments too high' },
    HIGH_INTEREST_OR_ARR: { value: 10026, text: 'Customer is no longer interested - High Interest or ARR' },
    DOES_NOT_WANT_TO_COMPLETE_LOAN_PROCESS: { value: 10027, text: 'Customer is no longer interested - Does not want to complete loan process' },
    NEEDS_THE_FUNDS_SOONER: { value: 10028, text: 'Customer is no longer interested - Needs the funds sooner' },
    ALREADY_GOT_ANOTHER_LOAN: { value: 10029, text: 'Customer is no longer interested - Already got another loan' },
    DOES_NOT_AGREE_WITH_THE_REPAYMENT_SCHEDULE: { value: 10030, text: 'Customer is no longer interested - Does not agree with the repayment schedule' }

  },

  LoanCorrectionReasonEnum: {
    PERSONAL: { value: 10000, text: 'Personal' },
    NAME_VERIFICATION: { value: 10001, text: 'Name Verification' },
    DOB_VERIFICATION: { value: 10002, text: 'DOB Verification' },
    SSN_VERIFICATION: { value: 10003, text: 'SSN Verification' },
    MISSING_OR_Incorrect_Military_Notes: { value: 10004, text: 'Missing / Incorrect Military Notes' },
    MISSING_OR_Incorrect_C_Notes: { value: 10005, text: 'Missing / Incorrect C Notes' },
    MISSING_OR_Incorrect_H_Notes: { value: 10006, text: 'Missing / Incorrect H Notes' },
    MISSING_OR_Incorrect_VIP_OR_CCI_Notes: { value: 10007, text: 'Missing /Incorrect VIP / CCI Notes' },
    UPDATE_HOME_NUMBER: { value: 10008, text: 'Update Home Number' },
    UPDATE_EMAIL_ADDRESS: { value: 10009, text: 'Update Email Address' },
    UPDATE_DNC_STATUS: { value: 10010, text: 'Update DNC Status' },
    UPDATE_MOBILE_NUMBER: { value: 10011, text: 'Update Mobile Number' },
    UPDATE_MILITARY_TAGGING: { value: 10012, text: 'Update Military Tagging' },
    UPDATE_ADDRESS: { value: 10013, text: 'Update Address' },
    UPDATE_NAME: { value: 10014, text: 'Update Name' },
    VERIFY_MILITARY_TAGGING: { value: 10015, text: 'Verify Military Tagging' },

    BANK: { value: 20000, text: 'Bank' },
    MISSING_OR_INCORRECT_CLEARED_PAYMENT_NOTES: { value: 20001, text: 'Missing / Incorrect Cleared Payment Notes' },
    MISSING_OR_INCORRECT_SE_NOTES: { value: 20002, text: 'Missing / Incorrect SE Notes' },
    MISSING_OR_INCORRECT_AUTO_BANK_NOTES: { value: 20003, text: 'Missing / Incorrect Auto bank Notes' },
    UPDATE_NAME_OF_PAYROLL: { value: 20004, text: 'Update Name of Payroll' },
    UPDATE_DDS_AVAILABILITY_ON_THE_ACCOUNT: { value: 20005, text: 'Update DDs availability on the account' },
    UPDATE_90_DAY_QUESTIONS: { value: 20006, text: 'Update 90 Day Questions' },
    UPDATE_VERIFICATION_METHOD: { value: 20007, text: 'Update Verification Method' },
    UPDATE_ADDRESS_VERIFIED_WITH_BANKER: { value: 20008, text: 'Update Address Verified with Banker' },
    UPDATE_UNLIMITED_ACH_CREDIT_OR_DEBIT: { value: 20009, text: 'Update Unlimited ACH Credit/Debit' },
    UPDATE_LIQUID_ACCOUNT: { value: 20010, text: 'Update Liquid Account' },
    UPDATE_ACCOUNT_HOLDER_OPTION: { value: 20011, text: 'Update Account Holder Option' },
    UPDATE_DDS: { value: 20012, text: 'Update DDs' },
    UPDATE_PAYROLL_DATES: { value: 20013, text: 'Update Payroll Dates' },
    UPDATE_BANK_AVAILABLE_BALANCE: { value: 20014, text: 'Update Bank Available Balance' },
    UPDATE_BANK_PHONE_NUMBER: { value: 20015, text: 'Update Bank Phone Number' },
    UPDATE_BANK_ACCOUNT_TYPE: { value: 20016, text: 'Update Bank Account Type' },
    UPDATE_BANK_ROUTING_NUMBER: { value: 20017, text: 'Update Bank Routing Number' },
    UPDATE_ACCOUNT_NUMBER: { value: 20018, text: 'Update Account Number' },
    UPDATE_BANK_NAME: { value: 20019, text: 'Update Bank Name' },
    VERIFY_DDS_AVAILABILITY_ON_THE_ACCOUNT: { value: 20020, text: 'Verify DDs availability on the account' },
    VERIFY_90_DAY_QUESTIONS: { value: 20021, text: 'Verify 90 Day Questions' },
    VERIFY_OPEN_LOANS: { value: 20022, text: 'Verify Open Loans' },
    VERIFY_BANK_AVAILABLE_BALANCE: { value: 20023, text: 'Verify Bank Available Balance' },
    VERIFY_ENDING_BALANCES: { value: 20024, text: 'Verify Ending balances' },
    VERIFY_ADDRESS_VERIFIED_WITH_BANKER: { value: 20025, text: 'Verify Address Verified with Banker' },
    VERIFY_UNLIMITED_ACH_CREDIT_OR_DEBIT: { value: 20026, text: 'Verify Unlimited ACH Credit/Debit' },
    VERIFY_LIQUID_ACCOUNT: { value: 20027, text: 'Verify Liquid Account' },
    VERIFY_BANK_ACCOUNT_TYPE: { value: 20028, text: 'Verify Bank Account Type' },
    VERIFY_ACCOUNT_HOLDER_OPTION: { value: 20029, text: 'Verify Account Holder Option' },
    VERIFY_BANK_ROUTING_NUMBER: { value: 20030, text: 'Verify Bank Routing Number' },
    VERIFY_ACCOUNT_NUMBER: { value: 20031, text: 'Verify Account Number' },
    VERIFY_DDS: { value: 20032, text: 'Verify DDs' },
    VERIFY_PAYROLL_DATES: { value: 20033, text: 'Verify Payroll Dates' },
    VERIFY_BANK_PHONE_NUMBER: { value: 20034, text: 'Verify Bank Phone Number' },
    VERIFY_BANK_NAME: { value: 20035, text: 'Verify Bank Name' },
    VERIFY_THE_MANDATORY_QUESTION_FOR_SPECIAL_VOB: { value: 20036, text: 'Verify the mandatory question for Special VOB' },
    VERIFY_THE_MANDATORY_QUESTION_FOR_CLOSED_ACCOUNT: { value: 20037, text: 'Verify the mandatory question for Closed Account' },
    VERIFY_THE_AFFILIATION_OF_THE_BANK: { value: 20038, text: 'Verify the affiliation of the bank' },
    MISSING_DL_ON_FILE: { value: 20039, text: 'Missing DL on File' },
    NEED_TO_PERFORM_VOB_FAST_PASS_IS_NOT_APPLICABLE: { value: 20040, text: 'Need to perform VOB Fast pass is not applicable' },
    DL_REQUIRED_TO_ESTABLISH_CORRECT_PF: { value: 20041, text: 'DL required to establish correct PF' },
    DL_REQUIRED_DUE_TO_BAD_PERFORMANCE_HISTORY: { value: 20042, text: 'DL required due to Bad performance history' },
    DL_REQUIRED_DUE_TO_PREVIOUSLY_DENIED_DUE_TO_OPEN_LOANS: { value: 20043, text: 'DL required due to previously denied due to open loans' },
    DL_REQUIRED_DUE_TO_DISCREPANCE_OF_BANK_DETAILS: { value: 20044, text: 'DL required due to discrepance of Bank details' },
    VERIFY_THE_NAME_OF_THE_MERCHANT_WIRE: { value: 20045, text: 'Verify the Name of the Merchant (Wire)' },
    VERIFY_THE_NAME_OF_THE_MERCHANT_PENDING_TRANSCATION: { value: 20046, text: 'Verify the Name of the Merchant (Pending transcation)' },
    VERIFY_THE_NAME_OF_THE_MERCHANT_REVERSALS_STOP_PAYMENT_TCA: { value: 20047, text: 'Verify the Name of the Merchant (Reversals,Stop Payment,TCA)' },

    EMPLOYMENT: { value: 30000, text: 'Employment' },
    MISSING_OR_INCORRECT_VOE_NOTES: { value: 30001, text: 'Missing / Incorrect VOE Notes' },
    MISSING_OR_INCORRECT_VALIDATION_NOTES: { value: 30002, text: 'Missing / Incorrect W# validation  Notes' },
    UPDATE_RECENT_PAY_DATE: { value: 30003, text: 'Update Recent Pay Date' },
    UPDATE_PAYROLL_FREQUENCY: { value: 30004, text: 'Update Payroll Frequency' },
    UPDATE_PAY_FLEX: { value: 30005, text: 'Update Pay Flex' },
    UPDATE_WORK_PHONE_NUMBER: { value: 30006, text: 'Update Work Phone Number' },
    UPDATE_PAYROLL_TYPE: { value: 30007, text: 'Update Payroll Type' },
    UPDATE_EMPLOYER_NAME: { value: 30008, text: 'Update Employer Name' },
    UPDATE_POSITION: { value: 30009, text: 'Update Position' },
    VERIFY_RECENT_PAY_DATE: { value: 30010, text: 'Verify Recent Pay Date' },
    VERIFY_AFFILIATION_PAYROLL_AND_EMPLOYER_NAME: { value: 30011, text: 'Verify Affiliation Payroll and Employer Name' },
    VERIFY_EMPLOYMENT_REGULAR: { value: 30012, text: 'Verify Employment - Regular' },
    VERIFY_EMPLOYMENT_STRONG: { value: 30013, text: 'Verify Employment - Strong' },
    VERIFY_PAYROLL_FREQUENCY: { value: 30014, text: 'Verify Payroll Frequency' },
    VERIFY_PAY_FLEX: { value: 30015, text: 'Verify Pay Flex' },
    VERIFY_WORK_PHONE_NUMBER: { value: 30016, text: 'Verify Work Phone Number' },
    VERIFY_PAYROLL_TYPE: { value: 30017, text: 'Verify Payroll Type' },
    VERIFY_EMPLOYER_NAME: { value: 30018, text: 'Verify Employer Name' },
    VERIFY_THE_POSITION: { value: 30019, text: 'Verify the Position' },

    PAYMENT: { value: 40000, text: 'Payment' },
    LOWER_LOAN_AMOUNT: { value: 40001, text: 'Lower Loan Amount' },
    MISSING_OR_INCORRECT_RETURNING_CUST_NOTES: { value: 40002, text: 'Missing / Incorrect Returning Cust Notes' },
    MISSING_OR_INCORRECT_LT_NOTES: { value: 40003, text: 'Missing / Incorrect LT Notes' },
    MISSING_OR_INCORRECT_EPO_NOTES: { value: 40004, text: 'Missing / Incorrect EPO Notes' },
    INCORRECT_OR_UPDATE_PAYMENT_SCHEDULE: { value: 40005, text: 'Incorrect / Update Payment Schedule' },
    INCORRECT_OR_UPDATE_OF_INSTALLMENT: { value: 40006, text: 'Incorrect / Update # of installment' },
    INCORRECT_OR_UPDATE_EFFECTIVITY: { value: 40007, text: 'Incorrect / Update Effectivity' },
    INCORRECT_OR_UPDATE_EXPEDITE_PAYMENT: { value: 40008, text: 'Incorrect / Update Expedite Payment' },

    DOCUMENTS: { value: 50000, text: 'Documents' },
    UPDATE_LA_NAME_OR_SIGNATURE: { value: 50001, text: 'Update LA - Name/Signature' },
    INCORRECT_OR_UPDATE_LA_BANK_DETAILS: { value: 50002, text: 'Incorrect / Update LA - Bank Details' },
    DAP_ADDITIONAL_INFORMATION: { value: 50003, text: 'DAP Additional Information' },
    VERIFY_WHY_IP_IS_NOT_WITHIN_US: { value: 50004, text: 'Verify why IP is not within US' },

    OPERATIONS: { value: 70000, text: 'Operations' },
    OPERATIONS_TRIGGER: { value: 70001, text: 'Operations Trigger' },

    TRIBE_OPERATION: { value: 90000, text: 'Tribe Operation' },
    INCORRECT_SSN: { value: 90001, text: 'Need to verify correct SSN' },
    INCORRECT_DOB: { value: 90002, text: 'Need to verify DOB' },
    INCORRECT_ADDRESS: { value: 90003, text: 'Need to verify Address' },
    INCORRECT_NAME: { value: 90004, text: 'Need to verify First and Last name' }
  },

  WorkQueueType: {
    AGENT_REVIEW: { value: 101, text: 'Agent Review' },
    CORRECTOR_REVIEW: { value: 102, text: 'Corrector Review' },
    UNDERWRITER_REVIEW: { value: 103, text: 'Underwriter Review' },
    TRIBE_REVIEW: { value: 104, text: 'Tribe Review' },
    POSITIVE_WITHDRAWN: { value: 105, text: 'Positive Withdraw' },
    NEGATIVE_WITHDRAWN: { value: 106, text: 'Negative Withdraw' },
    TO_BE_SIGNED: { value: 201, text: 'To Be Signed' },
    TO_BE_SUBMITTED: { value: 202, text: 'To Be Submitted' }
  },

  Category: {
    NEW_CUSTOMER: { value: 1, text: 'New Customer' },
    RETURNING_CUSTOMER: { value: 2, text: 'Returning Customer' },
    COLLECTION_CUSTOMER: { value: 3, text: 'Collection Customer' },
    ONLINE_CUSTOMER: { value: 4, text: 'Online Program' },
    DISCARD_CUSTOMER: { value: -1, text: 'Discard Customer' },
    OTHERS: { value: 0, text: 'Others' },
    JARVIS: { value: 6, text: 'Auto' }
  },
  Gender: [
    { value: 1, text: 'Male' },
    { value: 2, text: 'Female' },
    { value: 9, text: 'Unknown' }
  ],
  GenderEnum: {
    MALE: { value: 1, text: 'Male' },
    FEMALE: { value: 2, text: 'Female' },
    UNKNOWN: { value: 9, text: 'Unknown' }
  },
  NotificationTypeEnum: {
    SES_MESSAGE: { value: 1, text: 'SES_MESSAGE' },
    SMS_MESSAGE: { value: 2, text: 'SMS_MESSAGE' }
  },
  VwaReason: [
    { value: 20000, text: 'Default' },
    { value: 20004, text: 'EP Sent' },
    { value: 20003, text: 'Revoked' },
    { value: 20023, text: 'Cancel Revoked' },
    { value: 20020, text: 'Bankruptcy' },
    { value: 20018, text: 'Under Agency' },
    { value: 20005, text: 'WA Approved' },
    { value: 20010, text: 'Do Not Honor' },
    { value: 20002, text: 'No Info Found' },
    { value: 20008, text: 'Self Employed' },
    { value: 20007, text: 'Never Employed' },
    { value: 20013, text: 'On WA with Others' },
    { value: 20021, text: 'Payment Received' },
    { value: 20015, text: 'Insufficient Income' },
    { value: 20019, text: 'Pending Bankruptcy' },
    { value: 20006, text: 'No Longer Employed' },
    { value: 20014, text: 'Temporary Employee' },
    { value: 20009, text: 'Court Order Required' },
    { value: 20012, text: 'Court Order Required' },
    { value: 20022, text: 'No Response - 60 days' },
    { value: 20017, text: 'On LOA No Return Date' },
    { value: 20001, text: 'Email Notification Sent' },
    { value: 20011, text: 'Do not Accept Email/Fax' },
    { value: 20016, text: 'On LOA With Return Date' }
  ],
  State: [
    { value: 'AL', text: 'AL - Alabama' },
    { value: 'AK', text: 'AK - Alaska' },
    { value: 'AZ', text: 'AZ - Arizona' },
    { value: 'AR', text: 'AR - Arkansas' },
    { value: 'CA', text: 'CA - California' },
    { value: 'CO', text: 'CO - Colorado' },
    { value: 'CT', text: 'CT - Connecticut' },
    { value: 'DE', text: 'DE - Delaware' },
    { value: 'DC', text: 'DC - District of Columbia' },
    { value: 'FL', text: 'FL - Florida' },
    { value: 'GA', text: 'GA - Georgia' },
    { value: 'HI', text: 'HI - Hawaii' },
    { value: 'ID', text: 'ID - Idaho' },
    { value: 'IL', text: 'IL - Illinois' },
    { value: 'IN', text: 'IN - Indiana' },
    { value: 'IA', text: 'IA - Iowa' },
    { value: 'KS', text: 'KS - Kansas' },
    { value: 'KY', text: 'KY - Kentucky' },
    { value: 'LA', text: 'LA - Louisiana' },
    { value: 'ME', text: 'ME - Maine' },
    { value: 'MD', text: 'MD - Maryland' },
    { value: 'MA', text: 'MA - Massachusetts' },
    { value: 'MI', text: 'MI - Michigan' },
    { value: 'MN', text: 'MN - Minnesota' },
    { value: 'MS', text: 'MS - Mississippi' },
    { value: 'MO', text: 'MO - Missouri' },
    { value: 'MT', text: 'MT - Montana' },
    { value: 'NE', text: 'NE - Nebraska' },
    { value: 'NV', text: 'NV - Nevada' },
    { value: 'NH', text: 'NH - New Hampshire' },
    { value: 'NJ', text: 'NJ - New Jersey' },
    { value: 'NM', text: 'NM - New Mexico' },
    { value: 'NY', text: 'NY - New York' },
    { value: 'NC', text: 'NC - North Carolina' },
    { value: 'ND', text: 'ND - North Dakota' },
    { value: 'OH', text: 'OH - Ohio' },
    { value: 'OK', text: 'OK - Oklahoma' },
    { value: 'OR', text: 'OR - Oregon' },
    { value: 'PA', text: 'PA - Pennsylvania' },
    { value: 'PR', text: 'PR - Puerto Rico' },
    { value: 'RI', text: 'RI - Rhode Island' },
    { value: 'SC', text: 'SC - South Carolina' },
    { value: 'SD', text: 'SD - South Dakota' },
    { value: 'TN', text: 'TN - Tennessee' },
    { value: 'TX', text: 'TX - Texas' },
    { value: 'UT', text: 'UT - Utah' },
    { value: 'VT', text: 'VT - Vermont' },
    { value: 'VA', text: 'VA - Virginia' },
    { value: 'WA', text: 'WA - Washington' },
    { value: 'WV', text: 'WV - West Virginia' },
    { value: 'WI', text: 'WI - Wisconsin' },
    { value: 'WY', text: 'WY - Wyoming' }
  ],
  Language: [
    { value: 101, text: 'English', code: 'GB' },
    { value: 102, text: 'Spanish', code: 'ES' }
  ],
  LanguageEnum: {
    English: { value: 101, text: 'English', code: 'GB' },
    Spanish: { value: 102, text: 'Spanish', code: 'ES' }
  },
  PayrollType: [
    { value: 18000, text: 'Direct Deposit', code: 'D' },
    { value: 18001, text: 'Paper Check', code: 'P' },
    { value: 18002, text: 'Cash', code: 'C' },
    { value: 18003, text: 'Unemployed Insurance', code: 'U' }
  ],
  JobType: [
    { value: 1000, text: 'Full Time' },
    { value: 1001, text: 'Part Time' }
  ],
  PayrollFrequency: [
    { value: 17003, text: 'Weekly', period: 7, count: 52, code: 'W' },
    { value: 17000, text: 'Bi-Weekly', period: 14, count: 26, code: 'B' },
    { value: 17002, text: 'Semi-Monthly', period: 15, count: 24, code: 'S' },
    { value: 17001, text: 'Monthly', period: 30, count: 12, code: 'M' }
  ],
  PayrollFrequencyEnum: {
    WEEKLY: { value: 17003, text: 'Weekly', period: 7, count: 52, code: 'W' },
    BI_WEEKLY: { value: 17000, text: 'Bi-Weekly', period: 14, count: 26, code: 'B' },
    SEMI_MONTHLY: { value: 17002, text: 'Semi-Monthly', period: 15, count: 24, code: 'S' },
    MONTHLY: { value: 17001, text: 'Monthly', period: 30, count: 12, code: 'M' }
  },
  IncomeType: [
    { value: 7000, text: 'Disability Income', code: 'D' },
    { value: 7001, text: 'Social Security', code: 'S' },
    { value: 7002, text: 'Employed', code: 'E' },
    { value: 7003, text: 'Unemployed', code: 'U' },
    { value: 7004, text: 'Pension', code: 'P' },
    { value: 7005, text: 'Others (Child Support, Welfare etc.) ', code: 'O' }
  ],
  Source: {
    PURCHASE: { value: 1, text: 'Purchase' },
    RETURNING: { value: 2, text: 'Returning' },
    EXPRESS: { value: 4, text: 'Express' },
    TRANSFER: { value: 8, text: 'Loan Transfer' },
    MARKET: { value: 16, text: 'Market' }
  },
  LoanPhaseEnum: {
    LEAD_FILTERING: { value: 10000, text: 'Lead Filtering' },
    LOAN_ORIGINATION: { value: 20000, text: 'Loan Origination', abbr: 'pre-origination' },
    APPROVED: { value: 30000, text: 'Approved', abbr: 'post-origination' },
    PAYMENT_PROCESSING: { value: 40000, text: 'Payment Processing', abbr: 'post-origination' },
    LOAN_COLLECTION: { value: 50000, text: 'Loan Collection', abbr: 'collection' },
    TERMINATED: { value: 60000, text: 'Loan Terminated', abbr: 'terminated' }
  },
  LoanStatus: {
    PENDING_ORIGINATION: { value: 10001, text: 'Pending Origination' },

    CUSTOMER_REVIEW: { value: 20001, text: 'Customer Review' },
    AGENT_REVIEW: { value: 20002, text: 'Agent Review' },
    CHAT_REVIEW: { value: 20003, text: 'Chat Review' },
    UNDERWRITER_REVIEW: { value: 20004, text: 'Application Review' },
    TRIBE_REVIEW: { value: 20005, text: 'Tribe Review' },
    CORRECTOR_REVIEW: { value: 20006, text: 'Corrector Review' },
    TRIBE_NOAA_REVIEW: { value: 20007, text: 'Tribe NOAA Review' },

    PENDING_APPROVED: { value: 30001, text: 'Pending Approved', prefix: 'post-origination' },
    APPROVED: { value: 30002, text: 'Approved', prefix: 'post-origination' },

    NEW: { value: 40001, text: 'New', prefix: 'post-origination' },
    GOOD_STANDING: { value: 40002, text: 'Good Standing', prefix: 'post-origination' },
    PROCESSING: { value: 40003, text: 'Processing', prefix: 'post-origination' },
    WARNING: { value: 40004, text: 'Warning', prefix: 'post-origination' },
    PENDING_TRANSFERRED_PAID_OFF: { value: 40005, text: 'Pending Transferred Paid Off', prefix: 'post-origination' },
    RESOLVED: { value: 40006, text: 'resolved', prefix: 'post-origination' },
    UNRESOLVED: { value: 40007, text: 'unresolved', prefix: 'post-origination' },
    NEW_PAID_OFF: { value: 40106, text: 'Paid Off' },

    PENDING_COLLECTION: { value: 50001, text: 'Pending Collection', prefix: 'collection' },
    IN_HOUSE_COLLECTION: { value: 50101, text: 'In House Collection', prefix: 'collection' },
    PENDING_IN_HOUSE_APPROVE: { value: 50102, text: 'Pending In House Approve', prefix: 'collection' },
    IN_HOUSE_REPLAN: { value: 50103, text: 'In House Replan', prefix: 'collection' },
    IN_HOUSE_SETTLEMENT: { value: 50104, text: 'In House Settlement', prefix: 'collection' },
    IN_HOUSE_PAID_OFF_SETTLEMENT_QUEUE: { value: 60901, text: 'In House Settlement', prefix: 'collection' },
    IN_HOUSE_PAID_OFF_SETTLEMENT: { value: 40107, text: 'In House Settlement', prefix: 'collection' },
    PENDING_OUT_HOUSE_COLLECTION: { value: 50201, text: 'Pending External Collection', prefix: 'collection' },
    OUT_HOUSE_COLLECTION: { value: 50202, text: 'External Collection', prefix: 'collection' },
    OUT_HOUSE_POCKETED: { value: 50203, text: 'External Pocketed', prefix: 'collection' },
    PENDING_BANKRUPTCY: { value: 50301, text: 'Pending Bankruptcy', prefix: 'collection' },
    PENDING_CCCS: { value: 50401, text: 'Pending CCCS', prefix: 'collection' },
    PENDING_CANCELLATION: { value: 50501, text: 'Pending Cancellation', prefix: 'collection' },
    OUT_HOUSE_SETTLEMENT_QUEUE: { value: 60902, text: 'Out House Settlement', prefix: 'collection' },
    OUT_HOUSE_SETTLEMENT: { value: 40108, text: 'Out House Settlement', prefix: 'collection' },

    POSITIVE_WITHDRAWN: { value: 60001, text: 'Positive Withdrawn', prefix: 'pre-origination' },
    NEGATIVE_WITHDRAWN: { value: 60002, text: 'Negative Withdrawn', prefix: 'pre-origination' },
    MANUALLY_VOIDED: { value: 60101, text: 'Manually Voided', prefix: 'post-origination' },
    VOIDED: { value: 60102, text: 'Voided', prefix: 'post-origination' },
    GOOD_STANDING_PAID_OFF: { value: 60201, text: 'Good Standing Paid Off', prefix: 'post-origination' },
    PAID_OFF: { value: 60202, text: 'Paid Off', prefix: 'post-origination' },
    WARNING_PAID_OFF: { value: 60203, text: 'Warning Paid Off', prefix: 'post-origination' },
    TRANSFERRED_PAID_OFF: { value: 60204, text: 'Transferred Paid Off', prefix: 'post-origination' },
    IN_HOUSE_REPLAN_PAID_OFF: { value: 60205, text: 'In House Replan Paid Off', prefix: 'collection' },
    IN_HOUSE_SETTLEMENT_PAID_OFF: { value: 60206, text: 'In House Settlement Paid Off', prefix: 'collection' },
    OUT_HOUSE_PAID_OFF: { value: 60207, text: 'External Paid Off', prefix: 'collection' },
    OUT_HOUSE_CHARGE_OFF: { value: 60208, text: 'External Charge Off', prefix: 'collection' },
    TRANSFERRED_PENDING_PAID_OFF: { value: 60209, text: 'Transferred Pending Paid Off', prefix: 'post-origination' },
    CLOSED: { value: 60301, text: 'Closed', prefix: 'collection' },
    IN_HOUSE_REJECTED: { value: 60401, text: 'In House Rejected', prefix: 'collection' },
    OUT_HOUSE_REJECTED: { value: 60402, text: 'External Rejected', prefix: 'collection' },
    BANKRUPTCY: { value: 60501, text: 'Bankruptcy', prefix: 'collection' },
    CCCS: { value: 60601, text: 'CCCS', prefix: 'collection' },
    CANCELLATION: { value: 60701, text: 'Cancellation', prefix: 'collection' },
    MISCELLANEOUS: { value: 60801, text: 'Miscellaneous', prefix: 'collection' }
  },
  FollowUpType: {
    RELATIVE: { value: 201, text: 'Relative' },
    ABSOLUTE: { value: 202, text: 'Absolute' }
  },
  PaydayOnHolidayType: [
    { value: -1, text: 'Previous Business Day' },
    { value: 1, text: 'Next Business Day' }
  ],
  PaydayOnHolidayEnum: {
    PREVIOUS_DAY: { value: -1, text: 'Previous Business Day' },
    NEXT_DAY: { value: 1, text: 'Next Business Day' }
  },
  MultiActionRequestEnum: {
    PREVIEW: { value: 0, text: 'Preview' },
    SAVE: { value: 1, text: 'Save' },
    WRITE: { value: 2, text: 'Write' },
    INIT: { value: 3, text: 'init' }
  },
  BankAccountType: [
    { value: 3001, text: 'Checking Account', code: 'C' },
    { value: 3000, text: 'Savings Account', code: 'S' },
    { value: 3002, text: 'Money Market', code: 'M' }
  ],
  VoB: [
    { value: 1, text: 'Bank Call' },
    { value: 2, text: 'IBV' },
    { value: 3, text: 'Documents' }
  ],
  VobEnum: {
    BANK_CALL: { value: 1, text: 'Bank Call' },
    IBV: { value: 2, text: 'IBV' },
    DOCUMENTS: { value: 3, text: 'Documents' }
  },
  VoE: [
    { value: 1, text: 'Strong' },
    { value: 2, text: 'Regular' },
    { value: 3, text: 'None' }
  ],
  TransactionMode: [
    { value: 15000, text: 'ACH' },
    { value: 15001, text: 'Cash' },
    { value: 15002, text: 'Cashier Check' },
    { value: 15003, text: 'Credit Card' },
    { value: 15004, text: 'Debit Card' },
    { value: 15005, text: 'Money Gram' },
    { value: 15006, text: 'Money Order' },
    { value: 15007, text: 'Personal Check' },
    { value: 15008, text: 'Western Union' },
    { value: 15009, text: 'Wire' },
    { value: 15010, text: 'Loan Transfer' },
    { value: 15011, text: 'None' },
    { value: 15012, text: 'Wage Assignment' },
    { value: 15014, text: 'Instant Fund' },
    { value: 15016, text: 'Third Party' }
  ],
  TransactionTypeOptions: [
    { value: '14000', text: 'Credit' },
    { value: '14001', text: 'Debit' },
    { value: '14002', text: 'Refund' }
  ],
  ChangeType: [
    { value: 0, text: 'Normal' },
    { value: 101, text: 'Pay Off' },
    { value: 102, text: 'Pay Off In N Payments' },
    { value: 103, text: 'Pay Down' },
    { value: 104, text: 'Revoke Future ACH' },
    { value: 105, text: 'Change Payroll Date' },
    { value: 106, text: 'Change Payroll Frequency' },
    { value: 107, text: 'Change Payment Mode' },
    { value: 108, text: 'Change Payday On Holiday' },
    { value: 109, text: 'Change Payday On Available' },
    { value: 110, text: 'Manually Setup' },
    { value: 111, text: 'Pay Fixed Amount' },
    { value: 201, text: 'Skip Payment' },
    { value: 202, text: 'Makeup Full Payment' },
    { value: 203, text: 'Change Payment Amount' },
    { value: 204, text: 'Change Payment Mode' },
    { value: 205, text: 'Change Payment Date' },
    { value: 206, text: 'Makeup Partial Payment' },
    { value: 301, text: 'Reverse Credit' },
    { value: 302, text: 'Refund Debit' },
    { value: 303, text: 'Refund Bank Fee' },
    { value: 304, text: 'Refund Full Payment' },
    { value: 305, text: 'Refund Partial Payment' },
    { value: 306, text: 'Refund Payment' },
    { value: 901, text: 'Manual Reject' },
    { value: 902, text: 'Cancel Changes' },
    { value: 903, text: 'Manual Checked' },
    { value: 9527, text: 'Cancel' },
    { value: 404, text: 'Complaint' }
  ],
  PaymentMode: [{ value: 15000, text: 'ACH' }],
  FirstDayOfWeek: [
    { value: 2, text: 'Monday' },
    { value: 3, text: 'Tuesday' },
    { value: 4, text: 'Wednesday' },
    { value: 5, text: 'Thursday' },
    { value: 6, text: 'Friday' }
  ],
  DayOfMonth31: [
    { value: -1, text: 'Last day of month' },
    { value: 1, text: '1' },
    { value: 2, text: '2' },
    { value: 3, text: '3' },
    { value: 4, text: '4' },
    { value: 5, text: '5' },
    { value: 6, text: '6' },
    { value: 7, text: '7' },
    { value: 8, text: '8' },
    { value: 9, text: '9' },
    { value: 10, text: '10' },
    { value: 11, text: '11' },
    { value: 12, text: '12' },
    { value: 13, text: '13' },
    { value: 14, text: '14' },
    { value: 15, text: '15' },
    { value: 16, text: '16' },
    { value: 17, text: '17' },
    { value: 18, text: '18' },
    { value: 19, text: '19' },
    { value: 20, text: '20' },
    { value: 21, text: '21' },
    { value: 22, text: '22' },
    { value: 23, text: '23' },
    { value: 24, text: '24' },
    { value: 25, text: '25' },
    { value: 26, text: '26' },
    { value: 27, text: '27' },
    { value: 28, text: '28' },
    { value: 29, text: '29' },
    { value: 30, text: '30' },
    { value: 31, text: '31' }
  ],
  DayOfMonth: [
    { value: -11, text: 'Last B-Day Of Month' },
    { value: -12, text: 'Mid Of Month' },
    { value: -13, text: 'First B-Day Of Month' },
    { value: 1, text: '1' },
    { value: 2, text: '2' },
    { value: 3, text: '3' },
    { value: 4, text: '4' },
    { value: 5, text: '5' },
    { value: 6, text: '6' },
    { value: 7, text: '7' },
    { value: 8, text: '8' },
    { value: 9, text: '9' },
    { value: 10, text: '10' },
    { value: 11, text: '11' },
    { value: 12, text: '12' },
    { value: 13, text: '13' },
    { value: 14, text: '14' },
    { value: 15, text: '15' },
    { value: 16, text: '16' },
    { value: 17, text: '17' },
    { value: 18, text: '18' },
    { value: 19, text: '19' },
    { value: 20, text: '20' },
    { value: 21, text: '21' },
    { value: 22, text: '22' },
    { value: 23, text: '23' },
    { value: 24, text: '24' },
    { value: 25, text: '25' },
    { value: 26, text: '26' },
    { value: 27, text: '27' },
    { value: 28, text: '28' },
    { value: 29, text: '29' },
    { value: 30, text: '30' },
    { value: 31, text: '31' }
  ],
  DayOfSemiMonth: [
    { value: -1, text: 'Last day of month' },
    { value: 1, text: '1' },
    { value: 2, text: '2' },
    { value: 3, text: '3' },
    { value: 4, text: '4' },
    { value: 5, text: '5' },
    { value: 6, text: '6' },
    { value: 7, text: '7' },
    { value: 8, text: '8' },
    { value: 9, text: '9' },
    { value: 10, text: '10' },
    { value: 11, text: '11' },
    { value: 12, text: '12' },
    { value: 13, text: '13' },
    { value: 14, text: '14' },
    { value: 15, text: '15' },
    { value: 16, text: '16' },
    { value: 17, text: '17' },
    { value: 18, text: '18' },
    { value: 19, text: '19' },
    { value: 20, text: '20' },
    { value: 21, text: '21' },
    { value: 22, text: '22' },
    { value: 23, text: '23' },
    { value: 24, text: '24' },
    { value: 25, text: '25' },
    { value: 26, text: '26' },
    { value: 27, text: '27' },
    { value: 28, text: '28' },
    { value: 29, text: '29' },
    { value: 30, text: '30' },
    { value: 31, text: '31' }
  ],
  BooleanInBinary: [
    { value: true, text: 'Yes' },
    { value: false, text: 'No' }
  ],
  IbvStatus: [
    { value: 0, text: 'Not Started' },
    { value: 1, text: 'Started' },
    { value: 3, text: 'Verified' },
    { value: -1, text: 'Account Error' },
    { value: -2, text: 'Bank Error' }
  ],
  SignStatus: [
    { value: 0, text: 'Not Signed' },
    { value: 1, text: 'Signed' },
    { value: 2, text: 'Expired' },
    { value: 3, text: 'Cancelled' },
    { value: 4, text: 'Voided' },
    { value: 5, text: 'Suspended' },
    { value: 6, text: 'In Progress' },
    { value: 7, text: 'Voiding' },
    { value: 100, text: 'Recovering' }
  ],
  ReviewStatus: [
    { value: 101, text: 'Not Verified' },
    { value: 102, text: 'Verified' },
    { value: 103, text: 'Rejected' }
  ],
  ReviewStatusEnum: {
    NOT_VERIFY: { value: 101, text: 'Not Verified' },
    VERIFY: { value: 102, text: 'Verified' },
    CORRECT: { value: 103, text: 'Rejected' }
  },
  CustomerOptInType: {
    EMAIL: { value: 1, text: 'Email' },
    CELL_PHONE: { value: 2, text: 'Cell Phone' },
    HOME_PHONE: { value: 3, text: 'Home Phone' },
    WORK_PHONE: { value: 4, text: 'Work Phone' }
  },
  CorrectionReasonEnum: [
    {
      text: 'Personal',
      value: '100',
      items: [
        { text: 'Name verify', value: 101 },
        { value: 102, text: 'DOB Verification' },
        {
          value: 103,
          text: 'SSN Verification'
        },
        { value: 104, text: 'Missing / Incorrect Military Notes' },
        {
          value: 105,
          text: 'Missing / Incorrect C Notes'
        },
        { value: 106, text: 'Missing / Incorrect H Notes' },
        {
          value: 107,
          text: 'Missing / Incorrect VIP/CCI Notes'
        },
        { value: 108, text: 'Update Home Number' },
        { value: 109, text: 'Update  Email Address' },
        {
          value: 110,
          text: 'Update DNC Status'
        },
        { value: 111, text: 'Update Mobile Number' },
        { value: 112, text: 'Update  Military Tagging' },
        {
          value: 113,
          text: 'Update Address'
        },
        { value: 114, text: 'Update Name' },
        { value: 115, text: 'Verify  Military Tagging' }
      ]
    },
    {
      text: 'Bank',
      value: '200',
      items: [
        { text: 'Missing / Incorrect Cleared Payment Notes', value: 201 },
        {
          value: 202,
          text: 'Missing / Incorrect SE Notes'
        },
        { value: 203, text: 'Missing / Incorrect Auto bank Notes' },
        {
          value: 204,
          text: 'Update Name of Payroll'
        },
        { value: 205, text: 'Update DDs availability on the account' },
        {
          value: 206,
          text: 'Update 90 Day Questions'
        },
        { value: 207, text: 'Update Verification Method' },
        {
          value: 208,
          text: 'Update Address Verified with Banker'
        },
        { value: 209, text: 'Update Unlimited ACH Credit/Debit' },
        {
          value: 210,
          text: 'Update Liquid Account'
        },
        { value: 211, text: 'Update Account Holder Option' },
        { value: 212, text: 'Update DDs' },
        {
          value: 213,
          text: 'Update Payroll Dates'
        },
        { value: 214, text: 'Update Bank Available Balance' },
        {
          value: 214,
          text: 'Update Bank Phone Number'
        },
        { value: 216, text: 'Update Bank Account Type' },
        {
          value: 217,
          text: 'Update Bank Routing Number'
        },
        { value: 218, text: 'Update Account Number' },
        { value: 219, text: 'Update Bank Name' },
        {
          value: 220,
          text: 'Verify DDs availability on the account'
        },
        { value: 221, text: 'Verify 90 Day Questions' },
        { value: 222, text: 'Verify Open Loans' },
        {
          value: 223,
          text: 'Verify Bank Available Balance'
        },
        { value: 224, text: 'Verify Ending balances' },
        {
          value: 225,
          text: 'Verify Address Verified with Banker'
        },
        { value: 226, text: 'Verify Unlimited ACH Credit/Debit' },
        {
          value: 227,
          text: 'Verify Liquid Account'
        },
        { value: 228, text: 'Verify Bank Account Type' },
        {
          value: 229,
          text: 'Verify Account Holder Option'
        },
        { value: 230, text: 'Verify Bank Routing Number' },
        { value: 231, text: 'Verify Account Number' },
        {
          value: 232,
          text: 'Verify DDs'
        },
        { value: 233, text: 'Verify Payroll Dates' },
        { value: 234, text: 'Verify Bank Phone Number' },
        {
          value: 235,
          text: 'Verify Bank Name'
        },
        { value: 236, text: 'Verify the mandatory question for Special VOB' },
        {
          value: 237,
          text: 'Verify the mandatory question for Closed Account'
        },
        { value: 238, text: 'Verify the affiliation of the bank' },
        {
          value: 239,
          text: 'Missing DL on File'
        },
        { value: 240, text: 'Need to perform VOB Fast pass is not applicable' },
        {
          value: 241,
          text: 'DL required to establish correct PF'
        },
        { value: 242, text: 'DL required due to Bad performance history' },
        {
          value: 243,
          text: 'DL required due to previously denied due to open loans'
        },
        { value: 244, text: 'DL required due to discrepance of Bank details' },
        {
          value: 245,
          text: 'Verify the Name of the Merchant (Wire)'
        },
        { value: 246, text: 'Verify the Name of the Merchant (Pending transcation)' },
        {
          value: 247,
          text: 'Verify the Name of the Merchant (Reversals,Stop Payment,TCA)'
        }
      ]
    },
    {
      text: 'Employment',
      value: '300',
      items: [
        { text: 'Missing / Incorrect VOE Notes', value: 301 },
        {
          value: 302,
          text: 'Missing / Incorrect W# validation  Notes'
        },
        { value: 303, text: 'Update Recent Pay Date' },
        { value: 304, text: 'Update Payroll Frequency' },
        {
          value: 305,
          text: 'Update Pay Flex'
        },
        { value: 306, text: 'Update Pay Flex' },
        { value: 307, text: 'Update Work Phone Number' },
        {
          value: 308,
          text: 'Update Payroll Type'
        },
        { value: 309, text: 'Update Employer Name' },
        { value: 310, text: 'Update Position' },
        {
          value: 311,
          text: 'Verify Affiliation Payroll and Employer Name'
        },
        { value: 312, text: 'Verify Recent Pay Date' },
        { value: 313, text: 'Verify Employment - Regular' },
        {
          value: 314,
          text: 'Verify Employment - Strong'
        },
        { value: 315, text: 'Verify Payroll Frequency' },
        { value: 316, text: 'Verify Pay Flex' },
        {
          value: 317,
          text: 'Verify Work Phone Number'
        },
        { value: 318, text: 'Verify Payroll Type' },
        { value: 319, text: 'Verify Employer Name' },
        {
          value: 320,
          text: 'Verify the Position'
        }
      ]
    },
    {
      text: 'Payment',
      value: '400',
      items: [
        { text: 'Lower Loan Amount', value: 401 },
        {
          value: 402,
          text: 'Missing / Incorrect Returning Cust Notes'
        },
        { value: 403, text: 'Missing / Incorrect LT Notes' },
        { value: 404, text: 'Missing / Incorrect EPO Notes' },
        {
          value: 405,
          text: 'Incorrect / Update Payment Schedule'
        },
        { value: 406, text: 'Incorrect / Update # of installment' },
        {
          value: 407,
          text: 'Incorrect / Update Effectivity'
        },
        {
          value: 408,
          text: 'Incorrect / Update Expedite Payment'
        },
        { value: 409, text: 'Incorrect / Update Payment Mode' },
        {
          value: 410,
          text: 'Incorrect / Update Loan Amount'
        },
        {
          value: 411,
          text: 'Incorrect / Update Program'
        }
      ]
    },
    {
      text: 'Documents',
      value: '500',
      items: [
        { text: 'Update LA - Name/Signature', value: 501 },
        {
          value: 502,
          text: 'Incorrect / Update LA - Bank Details'
        },
        { value: 503, text: 'DAP Additional Information' },
        {
          value: 504,
          text: 'Verify why IP is not within US'
        }
      ]
    }
  ],
  NewCorrectionReasonEnum: [
    {
      text: 'Personal Information',
      value: '21000',
      items: [
        { value: 21001, text: 'Need to verify customer\'s Name' },
        { value: 21002, text: 'Need to correct/Reverify Address' },
        { value: 21003, text: 'Need to correct/Reverify SSN' },
        { value: 21004, text: 'Need to correct/Reverify Email Address' },
        { value: 21005, text: 'Need to correct/Reverify Contact Number' },
        { value: 21006, text: 'Need to correct/Reverify DOB' },
        { value: 21007, text: 'Need to correct/Reverify Military Status' }
      ]
    },
    {
      text: 'Employment Details',
      value: '22000',
      items: [
        { value: 22001, text: 'Need to correct/Reverify Employer\'s Name' },
        { value: 22002, text: 'Need to correct/Reverify Title/Position' },
        { value: 22003, text: 'Need to correct/Reverify required VOE Type' },
        { value: 22004, text: 'Need to correct/provide valid Work Phone #' }
      ]
    },
    {
      text: 'Payroll Information',
      value: '23000',
      items: [
        { value: 23001, text: 'Need to correct/Reverify Pay Flex' },
        { value: 23002, text: 'Need to correct/Reverify Payroll Frequency' },
        { value: 23003, text: 'Need to correct/Reverify Day of W/M Paid' },
        { value: 23004, text: 'Need to correct/Reverify Last Payroll Date' },
        { value: 23005, text: 'Need to correct/Reverify Need to verify Payroll name' }
      ]
    },
    {
      text: 'Bank Details',
      value: '24000',
      items: [
        { value: 24001, text: 'Need to correct/Reverify Bank Name' },
        { value: 24002, text: 'Need to correct/Reverify Routing Number' },
        { value: 24003, text: 'Need to correct/Reverify Account Type' },
        { value: 24004, text: 'Need to correct/Reverify Account Balance' },
        { value: 24005, text: 'Need to correct/Reverify Account Number' },
        { value: 24006, text: 'Need to correct/Reverify Bank Phone Number' },
        { value: 24007, text: 'Need to correct/Reverify 90 days Question' },
        { value: 24008, text: 'Need to correct/Reverify Bank Address' },
        { value: 24009, text: 'Need to correct/Reverify Ach Debit & Credit' },
        { value: 24010, text: 'Need to correct/Reverify Primary Account Holder' },
        { value: 24011, text: 'Need to correct/Reverify Funds Availability' }
      ]
    },
    {
      text: 'Bank Records',
      value: '25000',
      items: [
        { value: 25001, text: 'Need to correct/provide required Type of VOB' },
        { value: 25002, text: 'Need to correct/Reverify Payroll Dates' },
        { value: 25003, text: 'Need to correct/Reverify Payroll Type' },
        { value: 25004, text: 'Need to correct/Reverify Payroll Amount' },
        { value: 25005, text: 'Need to correct/Reverify Ending Balance' }
      ]
    },
    {
      text: 'Payment Details',
      value: '26000',
      items: [
        { value: 26001, text: 'Need to correct/Reverify Signature' },
        { value: 26002, text: 'Need to correct/Reverify Loan Agreement details' },
        { value: 26003, text: 'Need to correct/Reverify IP Location' }
      ]
    },
    {
      text: 'Others',
      value: '27000',
      items: [
        { value: 27001, text: 'Need to correct/Reverify Open loans' },
        { value: 27002, text: 'Need to obtain valid DL' },
        { value: 27003, text: 'New Sub category' }
      ]
    },
    {
      text: 'Tribe Operation',
      value: '28000',
      items: [
        { value: 28001, text: 'Need to verify correct SSN' },
        { value: 28002, text: 'Need to verify DOB' },
        { value: 28003, text: 'Need to verify Address' },
        { value: 28004, text: 'Need to verify First and Last name' },
        { value: 28005, text: 'Other Reasons' }
      ]
    }
  ],
  AuditSectionKey: [
    { value: '21000', text: 'Personal Information' },
    { value: '22000', text: 'Employment Details' },
    { value: '23000', text: 'Payroll Information' },
    { value: '24000', text: 'Bank Details' },
    { value: '25000', text: 'Bank Records' },
    { value: '26000', text: 'Payment Details' },
    { value: '27000', text: 'Others' },
    { value: '28000', text: 'Tribe Operation' }
  ],
  AuditReasonEnum: [
    { value: 21001, text: 'Need to verify customer\'s Name' },
    { value: 21002, text: 'Need to correct/Reverify Address' },
    { value: 21003, text: 'Need to correct/Reverify SSN' },
    { value: 21004, text: 'Need to correct/Reverify Email Address' },
    { value: 21005, text: 'Need to correct/Reverify Contact Number' },
    { value: 21006, text: 'Need to correct/Reverify DOB' },
    { value: 21007, text: 'Need to correct/Reverify Military Status' },
    { value: 22001, text: 'Need to correct/Reverify Employer\'s Name' },
    { value: 22002, text: 'Need to correct/Reverify Title/Position' },
    { value: 22003, text: 'Need to correct/Reverify required VOE Type' },
    { value: 22004, text: 'Need to correct/provide valid Work Phone #' },
    { value: 23001, text: 'Need to correct/Reverify Pay Flex' },
    { value: 23002, text: 'Need to correct/Reverify Payroll Frequency' },
    { value: 23003, text: 'Need to correct/Reverify Day of W/M Paid' },
    { value: 23004, text: 'Need to correct/Reverify Last Payroll Date' },
    { value: 23005, text: 'Need to correct/Reverify Need to verify Payroll name' },
    { value: 24001, text: 'Need to correct/Reverify Bank Name' },
    { value: 24002, text: 'Need to correct/Reverify Routing Number' },
    { value: 24003, text: 'Need to correct/Reverify Account Type' },
    { value: 24004, text: 'Need to correct/Reverify Account Balance' },
    { value: 24005, text: 'Need to correct/Reverify Account Number' },
    { value: 24006, text: 'Need to correct/Reverify Bank Phone Number' },
    { value: 24007, text: 'Need to correct/Reverify 90 days Question' },
    { value: 24008, text: 'Need to correct/Reverify Bank Address' },
    { value: 24009, text: 'Need to correct/Reverify Ach Debit & Credit' },
    { value: 24010, text: 'Need to correct/Reverify Primary Account Holder' },
    { value: 24011, text: 'Need to correct/Reverify Funds Availability' },
    { value: 25001, text: 'Need to correct/provide required Type of VOB' },
    { value: 25002, text: 'Need to correct/Reverify Payroll Dates' },
    { value: 25003, text: 'Need to correct/Reverify Payroll Type' },
    { value: 25004, text: 'Need to correct/Reverify Payroll Amount' },
    { value: 25005, text: 'Need to correct/Reverify Ending Balance' },
    { value: 26001, text: 'Need to correct/Reverify Signature' },
    { value: 26002, text: 'Need to correct/Reverify Loan Agreement details' },
    { value: 26003, text: 'Need to correct/Reverify IP Location' },
    { value: 27001, text: 'Need to correct/Reverify Open loans' },
    { value: 27002, text: 'Need to obtain valid DL' },
    { value: 27003, text: 'New Sub category' },
    { value: 28001, text: 'Need to verify correct SSN' },
    { value: 28002, text: 'Need to verify DOB' },
    { value: 28003, text: 'Need to verify Address' },
    { value: 28004, text: 'Need to verify First and Last name' },
    { value: 28005, text: 'Other Reasons' }
  ],
  AuditStatusEnum: {
    NOT_VERIFIED: { value: 0, text: 'Not Verified' },
    VERIFIED: { value: 1, text: 'Verified' }
  },
  OperatorIdConst: {
    SYSTEM_ACTION: { value: -1, text: 'SYSTEM_ACTION' },
    CUSTOMER_ACTION: { value: -2, text: 'CUSTOMER_ACTION' }
  },
  EventTypeEnum: {
    // Loan Log
    LOAN_STATUS_EVENT: { value: 11000, text: 'Loan Status Event', ignore: true },
    LOAN_STATUS_CHANGE: { value: 11001, text: 'Loan Status Change' },
    LOAN_REGISTRY_CHANGE: { value: 10002, text: 'Loan Registry Change' },
    EXPRESS_EVENT: { value: 12000, text: 'Express Event' },
    EXPRESS: { value: 12001, text: 'Express' },
    LOAN_TRANSFER: { value: 12002, text: 'Loan Transfer' },
    MILITARY_LENDING_ATC: { value: 12003, text: 'Military Lending Act' },
    COPY_LOAN: { value: 12004, text: 'Copy Loan' },

    // Document Log
    DOCUMENT_EVENT: { value: 21000, text: 'Document Event' },
    LOAN_AGREEMENT: { value: 21001, text: 'Loan Agreement' },
    CERTIFICATE_OF_EVIDENCE: { value: 21002, text: 'Certificate of Evidence' },
    IDENTIFY_DOCUMENT: { value: 21003, text: 'Identity Document' },
    BANK_DOCUMENT: { value: 21004, text: 'Bank Account' },
    OTHERS_DOCUMENT: { value: 21005, text: 'Other Document' },
    BANKRUPTCY: { value: 21006, text: 'Bankruptcy' },
    CCCS: { value: 21007, text: 'Cccs' },
    PAPER_CHECK: { value: 21008, text: 'Paper Check' },
    EMAIL_ATTACHMENTS: { value: 21009, text: 'Email Attachments' },
    POA: { value: 21011, text: 'POA' },
    ATTY_REP_EMAIL: { value: 21011, text: 'Atty Rep Email' },
    MONEY_ORDER_ATTACHMENTS: { value: 21012, text: 'Money Order Attachments' },
    ONLINE_VERIFICATION_OF_EMPLOYMENT: { value: 21013, text: 'Online Verification of Employment' },
    SCRA: { value: 21014, text: 'SCRA' },
    SEND_BACK_ON_TRACK_EMAIL: { value: 20000, text: 'Send Back on Track Email' },

    // Note Log
    NOTE_EVENT: { value: 31000, text: 'Note Event' },
    NOTE_CREATE: { value: 31001, text: 'Note Create' },
    NOTE_CHAT: { value: 31002, text: 'Note Chat' },
    SPECIAL_CONSIDERATION_TAG: { value: 31003, text: 'Special Consideration Tag' },
    // Operation Log
    OPERATION_EVENT: { value: 41000, text: 'Operation Event' },
    SYSTEM_IMPORT: { value: 41001, text: 'System Import' },
    LOCK: { value: 41002, text: 'Lock' },
    UNLOCK: { value: 41003, text: 'Unlock' },
    GRAB: { value: 41004, text: 'Grab' },
    FOLLOW_UP: { value: 41005, text: 'Follow Up' },
    SEND_LOAN_AGREEMENT: { value: 41006, text: 'Send Loan Agreement' },
    SEND_EMAIL: { value: 41007, text: 'Send Email' },
    CANCEL_FOLLOW_UP: { value: 41008, text: 'Cancel Follow Up' },
    TRIGGER_FOLLOW_UP: { value: 41009, text: 'Trigger Follow Up' },
    COLLECTION_SEND_EMAIL: { value: 41010, text: 'Collection Send Email' },
    VERBAL_AGREEMENT: { value: 41011, text: 'Verbal Agreement' },
    RECOVER_LOAN_AGREEMENT: { value: 41012, text: 'Recover Loan Agreement' },
    CORRECTION_REASONS: { value: 41013, text: 'Correction Reasons' },
    ADD_STAMP_REASON: { value: 41014, text: 'Add Stamp Reason' },
    REMOTE_CONSENT: { value: 41015, text: 'Remote consent' },
    E_SIGN_LINK_COMPRESS: { value: 41016, text: 'E Sign Link Compress' },
    SEND_EMAIL_FOR_ADD_INSTANT_DEBIT_CARD: { value: 41017, text: 'Send Email For Add Instant Debit Card' },
    VOIDED_LOAN_AGREEMENT: { value: 41018, text: 'Voided Loan Agreement' },
    SUSPENDED_LOAN_AGREEMENT: { value: 41019, text: 'Suspended Loan Agreement' },
    SEND_MARKETING_EMAIL: { value: 41020, text: 'Send Marketing Email' },
    MILITARY_CONFIRMATION: { value: 41021, text: 'Military Confirmation' },
    UNSUBSCRIPTION: { value: 41022, text: 'IBV Unsubscription' },
    // Payment Log
    PPS_TO_LCS_EVENT: { value: 51000, text: 'Move to LCS Event' },
    PPS_TO_LCS: { value: 51002, text: 'Loan Status PPS to LCS' },
    TRANSACTION_STATUS_EVENT: { value: 52000, text: 'Transaction Status Event' },
    TRANSACTION_STATUS_CHANGE: { value: 52001, text: 'Transaction Status Change' },
    TRANSACTION_AMOUNT_CHANGE: { value: 52003, text: 'Transaction Amount Change' },
    DELETE_TRANSACTION_SCHEDULE: { value: 52004, text: 'Delete Transaction Schedule' },
    UPDATE_TRANSACTION_SCHEDULE: { value: 52005, text: 'Update Transaction Schedule' },
    REQUEST_CHANGE_EVENT: { value: 53000, text: 'Request Change Event' },
    REQUEST_CHANGE: { value: 53001, text: 'Request Change' },
    REQUEST_SUBSEQUENT_ADVANCE: { value: 53002, text: 'Request Subsequent Advance' },
    REGISTRY_CHANGE_EVENT: { value: 54000, text: 'Registry Change Event' },
    REGISTRY_CHANGE: { value: 54001, text: 'Registry Change' },
    CUSTOMER_EXPLICIT_REVOCATION: { value: 54002, text: 'Customer Explicit Revocation' },
    // Maintenance Log
    MAINTENANCE_EVENT: { value: 60000, text: 'MAINTENANCE_EVENT' },
    ANT_EVENT: { value: 61000, text: 'ANT_EVENT' },
    ANT_PARAMETER_MODIFICATION: { value: 62000, text: 'ANT_PARAMETER_MODIFICATION' },
    ANT_SEND: { value: 63000, text: 'Send Batch' },
    INIT_SEND_PARAMETERS: { value: 63001, text: 'INIT_SEND_PARAMETERS' },
    GET_AND_PROCESS_DATA: { value: 63002, text: 'GET_AND_PROCESS_DATA' },
    GENERATE_AND_UPLOAD_FILE: { value: 63003, text: 'GENERATE_AND_UPLOAD_FILE' },
    PROCESS_BATCH_UPDATE: { value: 63004, text: 'PROCESS_BATCH_UPDATE' },
    ANT_RETURN: { value: 64000, text: 'Return Batch' },
    DOWNLOAD_AND_PARSE_SOURCE_FILE: { value: 64001, text: 'DOWNLOAD_AND_PARSE_SOURCE_FILE' },
    RETURN_INFORMATION_BY_TRANSACTION_NOS: { value: 64002, text: 'RETURN_INFORMATION_BY_TRANSACTION_NOS' },
    PROCESS_SINGLE_FILE: { value: 64003, text: 'PROCESS_SINGLE_FILE' },
    PROCESS_INSTALLMENT_TO_COLLECTION: { value: 64004, text: 'PROCESS_INSTALLMENT_TO_COLLECTION' },
    RETURN_BATCH_UPDATE: { value: 64005, text: 'RETURN_BATCH_UPDATE' },
    ANT_OVERRIDE: { value: 65000, text: 'Override' },
    ANT_MASSAGE: { value: 66000, text: 'Message' },
    ANT_CHECKED: { value: 67000, text: 'Checked Batch' },
    // Transaction Log
    TRANSACTION_EVENT: { value: 70000, text: 'TRANSACTION_EVENT' },
    TRANSACTION_SEND: { value: 71010, text: 'TRANSACTION_SEND' },
    TRANSACTION_RETURN: { value: 71020, text: 'TRANSACTION_RETURN' },
    TRANSACTION_AUTO_CHECKED: { value: 71030, text: 'TRANSACTION_AUTO_CHECKED' },
    TRANSACTION_WA_PAID_OFF: { value: 71040, text: 'TRANSACTION_WA_PAID_OFF' },
    TRANSACTION_WA_REJECTED: { value: 71041, text: 'TRANSACTION_WA_REJECTED' },
    TRANSACTION_WA_CHECKED: { value: 71042, text: 'TRANSACTION_WA_CHECKED' },
    TRANSACTION_PAY_DIT_CHECKED: { value: 71043, text: 'TRANSACTION_PAY_DIT_CHECKED' },
    MANUALLY_REJECT: { value: 72010, text: 'MANUALLY_REJECT' },
    MANUALLY_CHECKED: { value: 72020, text: 'MANUALLY_CHECKED' },
    MANUALLY_MOVE_TO_COLLECTION: { value: 72030, text: 'MANUALLY_MOVE_TO_COLLECTION' },
    // Collection Log
    COLLECTION_EVENT: { value: 80000, text: 'Collection Event' },
    COLLECTION_PAYMENT_CHANGE_EVENT: { value: 80101, text: 'Collection Payment Change' },
    COLLECTION_MANUALLY_PAID_OFF: { value: 80102, text: 'Collection Manually Paid Off' },
    COLLECTION_MOVE_TO: { value: 80103, text: 'Collection Move To' },
    COLLECTION_MANUALLY_SET_UP: { value: 80104, text: 'Collection Manually Set Up' },
    COLLECTION_PAY_OFF_IN_N: { value: 80105, text: 'Collection Pay Off In N' },
    COLLECTION_PAY_FIXED_AMOUNT: { value: 80106, text: 'Collection Pay Fixed Amount' },
    COLLECTION_SINGLE_CANCEL: { value: 80107, text: 'Collection Single Cancel' },
    COLLECTION_CONFIRM: { value: 80108, text: 'Collection Confirm' },
    VWA_EMAIL_NOTIFICATION_SENT: { value: 80109, text: 'VWA Email Notification Sent' },
    COLLECTION_RESOLVE_OVERFLOW: { value: 80110, text: 'Collection Resolve Overflow' },
    COLLECTION_WAIVED_FEE: { value: 80111, text: 'Collection Waived Fee' },
    VWA_FAX_NOTIFICATION_SENT: { value: 80112, text: 'VWA Fax Notification Sent' },
    VWA_UPDATE_EMPLOYER: { value: 80113, text: 'VWA Update Employer' },
    COLLECTION_GENERATE_FILE: { value: 80114, text: 'Collection Generate File' },
    UPDATE_WAGE_ASSIGNMENT: { value: 80115, text: 'Update WageAssignment' },
    PAY_DT: { value: 80116, text: 'PayDit Function' },
    REVOKE_WA: { value: 80117, text: 'Revoked WA' },
    VWA_UPDATE_REASON: { value: 80118, text: 'VWA Update Reason' },
    PAY_DT_CREATION_RETURN: { value: 80119, text: 'PayDit Creation Return' },
    PAY_DT_UPDATE_RETURN: { value: 80120, text: 'PayDit update return' },
    RESUME_LOAN: { value: 80121, text: 'Resume' },

    INSTANT_LITIGANT_VERIFICATION: { value: 100000, text: 'Instant Litigant Verification' }
  },
  EventLogType: [
    { TRANSACTION_WA_CHECKED: 71042 },
    { FOLLOW_UP: 41005 }
  ],
  DocumentTypeEnum: {
    IDENTITY_DOCUMENT: { value: 1, text: 'Identity document' },
    BANK_DOCUMENT: { value: 2, text: 'Bank document' },
    OTHERS_DOCUMENT: { value: 3, text: 'Others document' },
    LOAN_AGREEMENT: { value: 4, text: 'Loan Agreement' },
    CERTIFICATE_OF_EVIDENCE: { value: 5, text: 'Certificate of Evidence' },
    BANKRUPTCY: { value: 6, text: 'Bankruptcy' },
    CCCS: { value: 7, text: 'Cccs' },
    PAPER_CHECK: { value: 8, text: 'Paper Check' },
    EMAIL_ATTACHMENTS: { value: 9, text: 'Email Attachments' },
    POA: { value: 10, text: 'POA' },
    ATTY_REP_EMAIL: { value: 11, text: 'Atty Rep Email' },
    MONEY_ORDER_ATTACHMENTS: { value: 12, text: 'Money Order Attachments' },
    ONLINE_VERIFICATION_OF_EMPLOYMENT: { value: 13, text: 'Online Verification of Employment' },
    SCRA: { value: 14, text: 'SCRA' },
    CRC: { value: 15, text: 'Consent Record Certificate' }
  },
  LockLoanReasonEnum: {
    GRAB_LOAN: { value: 0, text: 'Grab Loan' },
    GENERATE_LOAN: { value: 1, text: 'Generate Loan' },
    CUSTOMER_SEARCH: { value: 2, text: 'Customer Search' },
    MANUAL_LOCK: { value: 3, text: 'Manual Lock' },
    AUTOMATIC_LOCK: { value: 4, text: 'Automatic Lock' }
  },
  UnlockLoanReasonEnum: {
    MANUAL_UNLOCK: { value: 0, text: 'Manual Unlock' },
    AUTO_UNLOCK_LEAVE_PAGE: { value: 1, text: 'Auto unlock is triggered by leaving the details page' },
    AUTO_UNLOCK_LONG_TIME_NO_OPERATION: { value: 2, text: 'Auto unlock is triggered by long time no operation' },
    LOCK_OTHER_LOAN: { value: 3, text: 'The current loan is automatically unlocked because other loans are locked' },
    STATUS_CHANGED: { value: 4, text: 'The current loan is automatically unlocked because the status is changed' },
    HANDLED_BY_RESOLUTION_DEPARTMENT: { value: 5, text: 'The current loan is auto unlocked because handled by resolution department' }
  },
  MilitaryEnum: {
    NOT_MILITARY: { value: 1, text: 'Not Military', abbr: 'NOT MLA' },
    UNKNOWN: { value: 0, text: 'Unknown', abbr: '' },
    MILITARY: { value: -1, text: 'Military', abbr: 'MLA' }
  },
  ChangeTypeEnum: {
    NORMAL: { value: 0, text: 'Normal' },
    PAY_OFF: { value: 101, text: 'Pay Off' },
    PAY_OFF_IN_N: { value: 102, text: 'Pay Off In N Payments' },
    PAY_DOWN: { value: 103, text: 'Pay Down' },
    REVOKE_ACH: { value: 104, text: 'Revoke Future ACH' },
    CHANGE_DATE: { value: 105, text: 'Change Payroll Date' },
    CHANGE_FREQUENCY: { value: 106, text: 'Change Payroll Frequency' },
    CHANGE_MODE: { value: 107, text: 'Change Payment Mode' },
    CHANGE_PAYDAY_ON_HOLIDAY: { value: 108, text: 'Change Payday On Holiday' },
    CHANGE_PAYDAY_ON_AVAILABLE: { value: 109, text: 'Change Payday On Available' },
    PAY_FIXED_AMOUNT: { value: 111, text: 'Pay Fixed Amount' },
    ASSIGNED_SKIP: { value: 201, text: 'Skip Payment' },
    ASSIGNED_MAKEUP: { value: 202, text: 'Makeup Full Payment' },
    ASSIGNED_AMOUNT: { value: 203, text: 'Change Payment Amount' },
    ASSIGNED_MODE: { value: 204, text: 'Change Payment Mode' },
    ASSIGNED_DATE: { value: 205, text: 'Change Payment Date' },
    ASSIGNED_MAKEUP_PARTIAL: { value: 206, text: 'Make Up Partial Payment' },
    REFUND_CREDIT: { value: 301, text: 'Reverse Credit' },
    REVERSE_DEBIT: { value: 302, text: 'Reverse Debit' },
    REFUND_BANK_FEE: { value: 303, text: 'Refund Bank Fee' },
    REFUND_FULL_PAYMENT: { value: 304, text: 'Refund Full Payment' },
    REFUND_PARTIAL_PAYMENT: { value: 305, text: 'Refund Partial Payment' },
    REFUND_PAYMENT: { value: 306, text: 'Refund Payment' },
    MANUAL_REJECT: { value: 901, text: 'Manual Reject' },
    CANCEL_CHANGE: { value: 902, text: 'Cancel Changes' },
    MANUAL_CHECKED: { value: 903, text: 'Manual Checked' },
    COLLECTION_SINGLE_CANCEL: { value: 9527, text: 'Cancel' },
    COMPLAINT: { value: 404, text: 'complaint' }
  },
  TransactionModeEnum: {
    ACH: { value: 15000, text: 'ACH' },
    CASH: { value: 15001, text: 'Cash' },
    CASHIER_CHECK: { value: 15002, text: 'Cashier Check' },
    CREDIT_CARD: { value: 15003, text: 'Credit Card' },
    DEBIT_CARD: { value: 15004, text: 'Debit Card' },
    MONEY_GRAM: { value: 15005, text: 'Money Gram' },
    MONEY_ORDER: { value: 15006, text: 'Money Order' },
    PERSONAL_CHECK: { value: 15007, text: 'Personal Check' },
    WESTERN_UNION: { value: 15008, text: 'Western Union' },
    WIRE: { value: 15009, text: 'Wire' },
    LOAN_TRANSFER: { value: 15010, text: 'Loan Transfer' },
    NONE: { value: 15011, text: 'None' },
    WAGE_ASSIGMENT: { value: 15012, text: 'Wage Assignment' },
    INSTANT_FUND: { value: 15014, text: 'Instant Fund' },
    PAPER_CHECK: { value: 15015, text: 'Paper Check' },
    THIRD_PARTY: { value: 15016, text: 'Third Party' }
  },
  LoanTypeEnum: {
    INSTALLMENT_LOAN: { value: 82010101, text: 'Installment Loan' },
    CREDIT_LINE_LOAN: { value: 82010102, text: 'Credit Line Loan' },
    MULTIPLE_ADVANCE_LOAN: { value: 82010103, text: 'Multiple Advance Loan' },
    SLAVE_LOAN: { value: 82010199, text: 'Slave Loan' }
  },
  SignStatusEnum: {
    NOT_SIGNED: { value: 0, text: 'Not Signed' },
    SIGNED: { value: 1, text: 'Signed' },
    EXPIRED: { value: 2, text: 'Expired' },
    CANCELLED: { value: 3, text: 'Canceled' },
    VOIDED: { value: 4, text: 'Voided' },
    SUSPENDED: { value: 5, text: 'Suspended' },
    IN_PROGRESS: { value: 6, text: 'In Progress' },
    VOID_IN_PROGRESS: { value: 7, text: 'Voiding' },
    RECOVER_IN_PROGRESS: { value: 100, text: 'Recovering' }
  },
  TransactionStatusEnum: {
    NONE: { value: 0, text: 'None' },
    PENDING: { value: 1, text: 'Pending' },
    NOT_CHECKED: { value: 2, text: 'Not Checked' },
    CHECKED: { value: 3, text: 'Checked' },
    REJECTED: { value: -1, text: 'Rejected' },
    UNKNOWN: { value: -3, text: 'Unknown' }
  },
  CategoryEnum: {
    NEW_CUSTOMER: { value: 1, text: 'New Customer' },
    RETURNING_CUSTOMER: { value: 2, text: 'Returning Customer' },
    COLLECTION_CUSTOMER: { value: 3, text: 'Collection Customer' },
    ONLINE_CUSTOMER: { value: 4, text: 'Online Program' },
    JARVIS: { value: 6, text: 'Jarvis' },
    DISCARD_CUSTOMER: { value: -1, text: 'Discard Customer' },
    OTHERS: { value: 0, text: 'Others' }
  },
  PaydayOnAvailableEnum: {
    SAME_DAY: { value: 0, text: 'Same Day' },
    NEXT_BUSINESS_DAY: { value: 1, text: 'Next Business Day' }
  },
  PaydayOnAvailable: [
    { value: 0, text: 'Same Day' },
    { value: 1, text: 'Next Business Day' }
  ],
  Move2CollectionEnum: {
    IN_HOUSE_COLLECTION: { value: 50101, text: 'In House Collection' },
    PENDING_IN_HOUSE_APPROVED: { value: 50102, text: 'Pending In House Approved' },
    IN_HOUSE_REPLAN: { value: 50103, text: 'In House Replan' },
    IN_HOUSE_SETTLEMENT: { value: 50104, text: 'In House Settlement' },
    PENDING_OUT_HOUSE_COLLECTION: { value: 50201, text: 'Pending External Collection' },
    OUT_HOUSE_COLLECTION: { value: 50202, text: 'External Collection' },
    PENDING_BANKRUPTCY: { value: 50301, text: 'Pending Bankruptcy' },
    PENDING_CCCS: { value: 50401, text: 'Pending CCCS' },
    PENDING_CANCELLATION: { value: 50501, text: 'Pending Cancellation' },
    MISCELLANEOUS: { value: 60801, text: 'Miscellaneous' }
  },
  Move2Collection: [
    { value: 50101, text: 'In House Collection' },
    // { value: 50102, text: 'Pending In House Approved' },
    // { value: 50103, text: 'In House Replan' },
    // { value: 50104, text: 'In House Settlement' },
    { value: 50201, text: 'Pending External Collection' },
    // { value: 50202, text: 'External Collection' },
    { value: 50301, text: 'Pending Bankruptcy' },
    { value: 50401, text: 'Pending CCCS' },
    // { value: 50501, text: 'Pending Cancellation' },
    { value: 60801, text: 'Miscellaneous' }
  ],
  PayrollTypeEnum: {
    DIRECT_DEPOSIT: { value: 18000, text: 'Direct Deposit' },
    PAPER_CHECK: { value: 18001, text: 'Paper Check' },
    CASH: { value: 18002, text: 'Cash' },
    UNEMPLOYED_INSURANCE: { value: 18003, text: 'Unemployed Insurance' }
  },
  JsonKeyConst: {
    ABSOLUTE_TIME: 'absoluteTime',
    ACCOUNT_BALANCE: 'accountBalance',
    ACCOUNT_NO: 'accountNo',
    ACCOUNT_TYPE: 'accountType',
    ACH_PROVIDER_ID: 'achProviderId',
    ACTION: 'action',
    ADDITIONAL_FEE: 'additionalFee',
    ADDRESS: 'address',
    SIGNER_IP_ADDRESS: 'signerIpAddress',
    AMOUNT: 'amount',
    AMOUNT_OF_OPEN_LOANS: 'amountOfOpenLoans',
    LOAN: 'loan',
    LOAN_ID: 'loanId',
    LOAN_PROPERTY: 'loanProperty',
    LOAN_NO: 'loanNo',
    LOAN_STATUS: 'loanStatus',
    LOAN_STATUS_TEXT: 'loanStatusText',
    APPLICATION_STATUS: 'applicationStatus',
    APPROVED_AMOUNT: 'approvedAmount',
    APPROVED_AT: 'approvedAt',
    APPROVED_BY: 'approvedBy',
    APPROVED_ID: 'approvedId',
    APR: 'apr',
    ASSIGNED_ID: 'assignedId',
    AUTHORIZATION_TYPE: 'authorizationType',
    AVATAR_URL: 'avatarUrl',

    BANK_ACCOUNT_BALANCE: 'bankAccountBalance',
    BANK_ACCOUNT_NO: 'bankAccountNo',
    BANK_ACCOUNT_OWNER: 'bankAccountOwner',
    BANK_ACCOUNT_TYPE: 'bankAccountType',
    BANK_FEE: 'bankFee',
    BANK_NAME: 'bankName',
    BANK_PHONE: 'bankPhone',
    BANK_ROUTING_NO: 'bankRoutingNo',
    BIRTHDAY: 'birthday',

    CATEGORY: 'category',
    CELL_PHONE: 'cellPhone',
    CHANGE_TYPE: 'changeType',
    CHARGES: 'charges',
    CITY: 'city',
    CLIENT_OFFSET: 'clientOffset',
    CODE: 'code',
    COLLECT_TIME: 'collectTime',
    COMMENTS: 'comments',
    CORRECTION_CODE: 'correctionCode',
    COUNT: 'count',
    CREATE_FILE_DATE: 'createFileDate',
    CREATE_TIME: 'createTime',
    CREATED_AT: 'createdAt',
    CREDIT_DATE: 'creditDate',
    CUSTOMER_ID: 'customerId',
    CERTIFICATE_URL: 'certificateUrl',
    CONTACT_START_TIME: 'contactStartTime',
    CONTACT_STOP_TIME: 'contactStopTime',
    CHANGE_AVATAR_URL: 'changeAvatarUrl',

    DATA: 'data',
    DATA_KEY: 'dataKey',
    DAY_IN_COLLECTION: 'dayInCollection',
    DEBIT_COUNT: 'debitCount',
    DEFAULT_DISBURSEMENT_MODE: 'defaultDisbursementMode',
    DEFAULT_REPAYMENT_MODE: 'defaultRepaymentMode',
    DEPARTMENT_ID: 'departmentId',
    DIRECT_DEPOSIT: 'directDeposit',
    DIRECT_DEPOSITS: 'directDeposits',
    DOCUMENT_NAME: 'documentName',
    DOCUMENT_STATUS: 'documentStatus',
    DOCUMENT_TYPE: 'documentType',
    DOCUMENT_URL: 'documentUrl',
    DRIVER_LICENSE_NO: 'driverLicenseNo',
    DRIVER_LICENSE_STATE: 'driverLicenseState',
    DUE_DATE: 'dueDate',

    EFFECTIVE_DATE: 'effectiveDate',
    EMAIL: 'email',
    EMPLOYER_FAX: 'employerFax',
    EMPLOYER_NAME: 'employerName',
    EMPLOYEE_NO: 'employeeNo',
    EMPLOYER_PHONE: 'employerPhone',
    EMPLOYER_PHONE_EXT: 'employerPhoneExt',
    EXPRESS: 'express',
    EVENT_DATA: 'eventData',
    EVENT_TIME: 'eventTime',
    EVENT_TYPE: 'eventType',
    EVENT_TYPE_TEXT: 'eventTypeText',
    END_OF_BALANCE: 'endOfBalance',
    END_TIME: 'endTime',
    EMPLOYER_STATE: 'employerState',
    EMPLOYER_CITY: 'employerCity',
    EMPLOYER_ZIP: 'employerZip',
    EMPLOYER_ADDRESS: 'employerAddress',

    FEATURE: 'feature',
    FURTHEST_STATUS: 'furthestStatus',
    FIELD_KEY: 'fieldKey',
    FIELD_VALUE: 'fieldValue',
    FIELD_NAME: 'fieldName',
    FIRST_CREDIT_DATE: 'firstCreditDate',
    FIRST_DAY_OF_MONTH: 'firstDayOfMonth',
    FIRST_DAY_OF_WEEK: 'firstDayOfWeek',
    FIRST_DEBIT_DATE: 'firstDebitDate',
    FIRST_NAME: 'firstName',
    FIRST_PAYROLL_DAY: 'firstPayrollDay',
    FLAG: 'flag',
    FLAGS: 'flags',
    FOLLOW_UP_AT: 'followUpAt',
    FOLLOWUP_BY: 'followupBy',
    FOLLOWUP_ID: 'followupId',
    FOLLOWUP_TYPE: 'followupType',
    FROZEN: 'frozen',
    FULL_NAME: 'fullName',
    FUTURE_PAYMENT_MODE: 'futurePaymentMode',
    FRAUD_STATUS: 'fraudStatus',

    GENDER: 'gender',

    HOME_PHONE: 'homePhone',

    IBV: 'ibv',
    IBV_STATUS: 'ibvStatus',
    ID: 'id',
    INDICATOR: 'indicator',
    INDICATOR_CODE: 'indicatorCode',
    INSTALLMENT_DATE: 'installmentDate',
    INTEREST: 'interest',
    INTEREST_RATE: 'interestRate',
    IS_DATE_STR: 'isDateStr',
    IS_FORCE: 'isForce',
    IS_MILITARY: 'isMilitary',
    IS_SEND_EMAIL: 'isSendEmail',
    IS_UNLOCK_OLD: 'isUnlockOld',
    INCOME_TYPE: 'incomeType',

    JOB_TYPE: 'jobType',

    KEY: 'key',

    SIGNATURE_SOURCE: 'signatureSource',
    MARKETING_EMAIL: 'marketingEmail',
    MILITARY_CONFIRMATION: 'Military Confirmation',
    SYSTEM_VERIFICATION: 'systemVerification',
    AGENT_VERIFICATION: 'agentVerification',

    LANGUAGE_CODE: 'languageCode',
    LANGUAGE_NAME: 'languageName',
    LAST_DEBIT_DATE: 'lastDebitDate',
    LAST_ACTION_DATE: 'lastActionDate',
    LAST_PAYMENT_DATE: 'lastPaymentDate',
    LAST_PAYDAY: 'lastPayday',
    LAST_RETURN_CODE: 'lastReturnCode',
    LAST_RETURN_DATE: 'lastReturnDate',
    LAST_NAME: 'lastName',
    LATE_FEE: 'lateFee',
    LATEST_IN: 'latestIn',
    LEAD_ID: 'leadId',
    LEFT_INTEREST: 'leftInterest',
    LEFT_LATE_FEE: 'leftLateFee',
    LEFT_NSF_FEE: 'leftNsfFee',
    LEAD_PROVIDER_ID: 'leadProviderId',
    LEAD_PROVIDER_LIST: 'leadProviderList',
    LEAD_PROVIDER_NAME: 'leadProviderName',
    LEFT_PRINCIPAL: 'leftPrincipal',
    LOAN_SIZE_AMOUNT: 'loanSizeAmount',
    LOAN_TRANSFER_AMOUNT: 'loanTransferAmount',
    LOCK_REASON: 'lockReason',
    LOCKED_AT: 'lockedAt',
    LOCKED_BY: 'lockedBy',
    LOCKED_ID: 'lockedId',
    LOAN_AGREEMENT_CODE: 'loanAgreementCode',
    LOAN_AGREEMENT_URL: 'loanAgreementUrl',
    LOAN_AMOUNT: 'loanAmount',
    LANGUAGE: 'language',

    MAXIMUM_AMOUNT: 'maximumAmount',
    MAXIMUM_LOAN_SIZE: 'maximumLoanSize',
    MESSAGE: 'message',
    MIDDLE_NAME: 'middleName',
    MILITARY: 'military',
    MINIMUM_AMOUNT: 'minimumAmount',
    MINIMUM_LOAN_SIZE: 'minimumLoanSize',
    MONTHLY_INCOME: 'monthlyIncome',

    NEW_INTEREST: 'newInterest',
    NEW_LATE_FEE: 'newLateFee',
    NEW_NSF_FEE: 'newNsfFee',
    NEW_PRINCIPAL: 'newPrincipal',
    NEXT_PAYROLL_DATE: 'nextPayrollDate',
    NOTE: 'note',
    NSF_FEE: 'nsfFee',
    NUMBER_OF_OPEN_LOANS: 'numberOfOpenLoans',
    NUMBER_OF_PAID_LOANS: 'numberOfPaidLoans',

    OPERATE_BY: 'operateBy',
    OPERATED_BY: 'operatedBy',
    OPERATED_ID: 'operatedId',
    OPERATOR: 'operator',
    OPERATOR_DATA: 'operatorData',
    OPERATOR_ID: 'operatorId',
    OPERATOR_NAME: 'operatorName',
    OPTION: 'option',
    OWNER_DATA: 'ownerData',
    OUTPUT: 'output',

    PASSWORD: 'password',
    PAYDAY_ON_AVAILABLE: 'paydayOnAvailable',
    PAYDAY_ON_HOLIDAY: 'paydayOnHoliday',
    PAYMENT_MODE: 'paymentMode',
    PAYROLL_FREQUENCY: 'payrollFrequency',
    PHASE: 'phase',
    PHONE_NUMBER: 'phoneNumber',
    PORTFOLIO: 'portfolio',
    PORTFOLIO_ID: 'portfolioId',
    PORTFOLIO_NAME: 'portfolioName',
    POSITION: 'position',
    PRINCIPAL: 'principal',
    PRIORITY: 'priority',
    PROGRAM: 'program',
    PROGRAM_ID: 'programId',
    PROGRAM_NAME: 'programName',
    PAYROLL_TYPE: 'payrollType',
    PROCEDURES: 'procedures',
    PROGRAM_TEXT: 'programText',

    REASON: 'reason',
    RECEIVE_SMS: 'receiveSms',
    RECORD_ID: 'recordId',
    REFUND_FEE: 'refundFee',
    REGULAR_AMOUNT: 'regularAmount',
    RELATIVE_TIME: 'relativeTime',
    REMOTE_CONSENT_FLAG: 'remoteConsentFlag',
    REQUEST_RAW_DATA: 'requestRawData',
    REQUEST_TIME: 'requestTime',
    REQUESTED_AMOUNT: 'requestedAmount',
    RESPONSE_RAW_DATA: 'responseRawData',
    RESPONSE_TIME: 'responseTime',
    RETURN_CODE: 'returnCode',
    RETURN_DATA: 'returnData',
    RETURN_DATE: 'returnDate',
    RETURN_DESCRIPTION: 'returnDescription',
    REVIEW_DATA_ID: 'reviewDataId',
    REFERENCE_PHONE: 'referencePhone',
    REFERENCE_FIRST_NAME: 'referenceFirstName',
    REFERENCE_LAST_NAME: 'referenceLastName',
    REFERENCE_RELATIONSHIP: 'referenceRelationship',
    ROLE_CODE: 'roleCode',
    REQUEST_CODE: 'requestCode',
    PROVIDER: 'provider',
    CONTACT_TYPE: 'contactType',
    SC_NOTE: 'scNote',
    TYPE: 'type',

    VALIDATION_OF_EMPLOYMENT: 'validationOfEmployment',
    VALUE: 'value',
    VERBAL_AGREEMENT_ID: 'verbalAgreementId',
    VERBAL_AGREEMENT_NAME: 'verbalAgreementName',
    VERIFY_METHOD: 'verifyMethod',
    VOE: 'voe',

    SCHEDULE: 'schedule',
    SCHEDULE_ID: 'scheduleId',
    SCHEDULE_ITEM_ARRAY: 'scheduleItemArray',
    SCHEDULE_ITEM_ID: 'scheduleItemId',
    SCORE: 'score',
    PROPERTY_SECTION_ID: 'propertySectionId',
    SEARCH_INFO: 'searchInfo',
    SECTION_NAME: 'sectionName',
    SECOND_DAY_OF_MONTH: 'secondDayOfMonth',
    SECOND_PAYROLL_DAY: 'secondPayrollDay',
    SEND_BACK_BY: 'sendBackBy',
    SEND_EMAIL_DATE: 'sendEmailDate',
    SENT_AT: 'sentAt',
    SIGN_STATUS: 'signStatus',
    SIGNED_AT: 'signedAt',
    SIGNATURE_STATUS: 'signatureStatus',
    SLAVE_LOAN_STATUS: 'slaveLoanStatus',
    SOURCE: 'source',
    SOURCE_DATA: 'sourceData',
    SSN: 'ssn',
    START_TIME: 'startTime',
    STATE: 'state',
    STATUS: 'status',
    SUBMITTED_BY: 'submittedBy',
    SUBMITTED_ID: 'submittedId',
    SUMMARY: 'summary',
    SECOND_DAY_OF_WEEK: 'secondDayOfWeek',
    SUPERVISOR_PHONE: 'supervisorPhone',
    SUPERVISOR_NAME: 'supervisorName',
    SHIFT_START_TIME: 'shiftStartTime',
    SHIFT_STOP_TIME: 'shiftStopTime',
    SORT_ORDER: 'sortOrder',

    TARGET_DATA: 'targetData',
    THIRD_PARTY_FILE: 'thirdPartyFile',
    THIRD_PARTY_NAME: 'thirdPartyName',
    THIRD_PARTY_TIME: 'thirdPartyTime',
    THREAD_ID: 'threadId',
    TIME: 'time',
    TOTAL_ADDITIONAL_FEE: 'totalAdditionalFee',
    TOTAL_AMOUNT: 'totalAmount',
    TOTAL_BANK_FEE: 'totalBankFee',
    TOTAL_INTEREST: 'totalInterest',
    TOTAL_LATE_FEE: 'totalLateFee',
    TOTAL_LEFT: 'totalLeft',
    TOTAL_NSF_FEE: 'totalNsfFee',
    TOTAL_PRINCIPAL: 'totalPrincipal',
    TOTAL_PRINCIPAL_AMOUNT: 'totalPrincipalAmount',
    TOTAL_REFUND: 'totalRefund',
    TOTAL_WAIVED_ADDITIONAL_FEE: 'totalWaivedAdditionalFee',
    TOTAL_WAIVED_AMOUNT: 'totalWaivedAmount',
    TOTAL_WAIVED_INTEREST: 'totalWaivedInterest',
    TOTAL_WAIVED_LATE_FEE: 'totalWaivedLateFee',
    TOTAL_WAIVED_NSF_FEE: 'totalWaivedNsfFee',
    TOTAL_WAIVED_PRINCIPAL: 'totalWaivedPrincipal',
    TRANSACTION_DATE: 'transactionDate',
    TRANSACTION_MODE: 'transactionMode',
    TRANSACTION_NO: 'transactionNo',
    TRANSACTION_STATUS: 'transactionStatus',
    TRANSACTION_TYPE: 'transactionType',
    TELEPHONE: 'telephone',
    TOKEN: 'token',

    UNLOCK_REASON: 'unlockReason',
    UNPAID_FEE: 'unpaidFee',
    UPDATE_TIME: 'updateTime',
    UPDATED_AT: 'updatedAt',
    MILITARY_LENDING_ATC: 'mlaState',

    WAIVED_ADDITIONAL_FEE: 'waivedAdditionalFee',
    WAIVED_AMOUNT: 'waivedAmount',
    WAIVED_FEE: 'waivedFee',
    WAIVED_INTEREST: 'waivedInterest',
    WAIVED_LATE_FEE: 'waivedLateFee',
    WAIVED_NSF_FEE: 'waivedNsfFee',
    WAIVED_PRINCIPAL: 'waivedPrincipal',
    WEIGHT: 'weight',
    WEST_SIDE_LENDING: 'West Side Lending',
    WITHDRAW_CODE: 'withdrawCode',

    ZIP: 'zip',
    ILV_STATE: 'ilvState'
  },
  eventDataHideEventLog: [
    'programId',
    'loanId',
    'applicationId',
    'portfolioId',
    'customerId',
    'requestId',
    'companyId',
    'verbalAgreementId'
  ],
  diffHideEventLog: [
    'program',
    'programId',
    'lockedId',
    'lockedBy',
    'lockedAt',
    'loanStatusText',
    'applicationStatusText',
    'phase',
    'enteredAt',
    'submittedId',
    'submittedBy',
    'followupAt',
    'followupId',
    'followupBy',
    'approvedId',
    'approvedBy',
    'approvedAt',
    'priority',
    'directDeposit',
    'flags',
    'source',
    'sendEmailDate',
    'isSendEmail',
    'generatedAt',
    'extensionData',
    'furthestStatus',
    'loanId',
    'applicationId',
    'portfolioId',
    'customerId',
    'requestId',
    'companyId',
    'verbalAgreementId'
  ],
  TotalDayOfMonthEnum: {
    LAST_B_DAY_OF_MONTH: { value: '-11', text: 'Last B-Day Of Month' },
    MID_OF_MONTH: { value: '-12', text: 'Mid Of Month' },
    FIRST_B_DAY_OF_MONTH: { value: '-13', text: 'First B-Day Of Month' },
    MINUS_ONE: { value: '-1', text: 'Last day of month' },
    ONE: { value: '1', text: '1' },
    TWO: { value: '2', text: '2' },
    THREE: { value: '3', text: '3' },
    FOUR: { value: '4', text: '4' },
    FIVE: { value: '5', text: '5' },
    SIX: { value: '6', text: '6' },
    SEVEN: { value: '7', text: '7' },
    EIGHT: { value: '8', text: '8' },
    NINE: { value: '9', text: '9' },
    TEN: { value: '10', text: '10' },
    ELEVEN: { value: '11', text: '11' },
    TWELVE: { value: '12', text: '12' },
    THIRTEEN: { value: '13', text: '13' },
    FOURTEEN: { value: '14', text: '14' },
    FIFTEEN: { value: '15', text: '15' },
    SIXTEEN: { value: '16', text: '16' },
    SEVENTEEN: { value: '17', text: '17' },
    EIGHTEEN: { value: '18', text: '18' },
    NINETEEN: { value: '19', text: '19' },
    TWENTY: { value: '20', text: '20' },
    TWENTY_ONE: { value: '21', text: '21' },
    TWENTY_TWO: { value: '22', text: '22' },
    TWENTY_THREE: { value: '23', text: '23' },
    TWENTY_FOUR: { value: '24', text: '24' },
    TWENTY_FIVE: { value: '25', text: '25' },
    TWENTY_SIX: { value: '26', text: '26' },
    TWENTY_SEVEN: { value: '27', text: '27' },
    TWENTY_EIGHT: { value: '28', text: '28' },
    TWENTY_NINE: { value: '29', text: '29' },
    THIRTY: { value: '30', text: '30' },
    THIRTY_ONE: { value: '31', text: '31' }
  },
  PrivilegeType: {
    READABLE: 4,
    WRITABLE: 2,
    EXECUTABLE: 1
  },
  PrivilegeCode: {
    WELCOME: '10000001',
    WORKBENCH: '10100001',
    LOAN_QUEUE: '10100002',
    LOAN_DETAIL: '10100003',
    MANUALLY_CREATE_LEAD: '10101004',
    WORKBENCH_SEARCH: '10101005',
    LOAN_QUEUE_POST: '10200002',
    LOAN_DETAIL_POST: '10200003',
    SPECIAL_QUEUE: '10102004',
    COMPLAINT_QUEUE: '10102005',
    TO_BE_CONFIRMED_QUEUE: '10102006',
    LOAN_QUEUE_LCS: '10300001',
    LOAN_DETAIL_LCS: '10300002',
    WA_QUEUE: '90000000',
    WA_UPLOAD: '10103004',
    SEND_EMAIL_TO_CUSTOMER: '10103005',
    WA_DOWNLOAD: '10103006',
    IN_HOUSE_QUEUE_MENU: '10103007',
    CCCS_QUEUE_MENU: '10103008',
    BANKRUPTCY_QUEUE_MENU: '10103009',
    MISCELLANEOUS_QUEUE_MENU: '10103010',
    IN_HOUSE_OVERFLOW_QUEUE_MENU: '10103011',
    EXTERNAL_OVERFLOW_QUEUE_MENU: '10103012',
    SEND_EMAIL_TO_EMPLOYER: '10103013',
    SEND_FAX_TO_EMPLOYER: '10103014',
    COLLECTION_MANAGEMENT: '10103015',
    IN_HOUSE_SPECIAL_QUEUE_MENU: '10103016',
    THIRD_PARTY_MENU: '10103017',
    COMPLAINT_FILTER_MANAGEMENT_MENU: '10306001',
    SSN_FILTER_MANAGEMENT_MENU: '10306002',
    CUSTOMER_SEARCH: '20010001',
    INSTANT_DEBIT_CARD: '20010002',
    IGNORE_PORTFOLIO: '20010003',
    SHOW_OPERATED_BY: '20010004',
    CUSTOMER_SEARCH_CROSS_PORTFOLIO: '20010005',
    HANDLED_BY_RESOLUTIONS_DEPARTMENT: '20010007',
    NOTE_CREATE_LOG_DELETE: '20010009',
    INSTANT_LITIGANT_VERIFICATION_STATUS: '20010010',
    GENERATE_NEW_LOAN: '20110001',
    FOLLOW_UP: '20110002',
    SEND_EMAIL: '20110003',
    ADD_DOCUMENTS: '20110004',
    ADD_NOTES: '20110005',
    RFE: '20110006',
    EXPRESS: '20110007',
    TRANSFER: '20110008',
    AUTO_FORWARD_TO_UNDERWRITER_AFTER_SIGNED_LOAN_AGREEMENT: '20110009',
    DIAL: '20110010',
    DISPLAY_ACTIVE_LOANS_IN_QUEUE: '20110011',
    MANUAL_RE_CALCULATE_LOAN_AMOUNT: '20110012',
    ADJUST_APPROVED_AMOUNT: '20110013',
    CUSTOMER_OPT_IN_SETTING: '20110014',
    LOAN_HISTORY: '20110015',
    DOWNLOAD_FILE: '20110016',
    PERSONALLY_IDENTIFIABLE_INFORMATION: '20110017',
    SEND_TO_CUSTOMER_REVIEW: '20110018',
    SEND_TO_UNDERWRITER_REVIEW: '20110019',
    SEND_TO_TRIBE_REVIEW: '20110020',
    SEND_TO_TRIBE_NOAA_REVIEW: '20110039',
    SEND_TO_CORRECTOR_REVIEW: '20110021',
    TRIBE_DENY_LOAN: '20110022',
    TRIBE_APPROVE_LOAN: '20110023',
    INSTANT_BANK_VERIFICATION: '20110024',
    SCRIPT_OVERVIEW: '20110025',
    DOCUMENT_OVERVIEW: '20110026',
    SEND_TO_AGENT_REVIEW: '20110027',
    STAMP_VERIFICATION: '20110028',
    SPECIAL_CONSIDERATION: '20110029',
    PAYMENT_PLAN_EMULATOR: '20110030',
    AUDIT: '20110031',
    LOAN_AMOUNT_WARNING_ICON: '20110032',
    IS_SKIP_CHECK_BLACK_LIST: '20110033',
    AUDITED_TO_AGENT_REVIEW_OPTION: '20110034',
    AUDITED_TO_CORRECTOR_REVIEW_OPTION: '20110035',
    DISPLAY_DECLINE_ICON_IN_RIGHT_PANEL: '20110036',
    UNDER_CONSULTATION_BUTTON: '20110037',
    SPECIAL_CONSIDERATION_REASON: '20110040',
    TRACKER_LIST: '20111001',
    VISIT_TREND_CHART: '20111002',
    APPROVED_NUMBER_CHART: '20111003',
    APPROVED_AMOUNT_CHART: '20111004',
    CONTRIBUTION_CHART: '20111005',
    SORT_BY_UPDATED_AT: '20112001',
    FILTER_BY_DATE_RANGE: '20112002',
    FILTER_BY_TODAY: '20112003',
    FILTER_BY_YESTERDAY: '20112004',
    FILTER_BY_7_DAYS: '20112005',
    FILTER_BY_30_DAYS: '20112006',
    GOTO_DETAIL: '20112007',
    AGENT_REVIEW_QUEUE: '20112008',
    CORRECTOR_REVIEW_QUEUE: '20112009',
    UNDERWRITER_REVIEW_QUEUE: '20112010',
    TRIBE_REVIEW_QUEUE: '20112011',
    TRIBE_NOAA_REVIEW: '20112023',
    TO_BE_SIGNED_QUEUE: '20112012',
    TO_BE_SUBMITTED_QUEUE: '20112013',
    POSITIVE_WITHDRAWN_QUEUE: '20112014',
    NEGATIVE_WITHDRAWN_QUEUE: '20112015',
    TRIBE_REVIEW_BATCH_APPROVE: '20112016',
    RETURNING_QUEUE: '20112017',
    EXPORT_UNDERWRITER_QUEUE: '20112018',
    IS_DISPLAY_UNDERWRITER_QUEUE_AMOUNT: '20112019',
    FRAUD_WARNING_QUEUE: '20112020',
    RETURNED_FROM_UNDERWRITER_REVIEW: '20112021',
    PRE_SUSPECTED_LITIGANT_QUEUE: '20112022',
    COPY_LOAN: '20113001',
    LOCK_LOAN: '20113002',
    GRAB_LOAN: '20113003',
    REFRESH_ESIGN_STATUS: '20113004',
    LOAN_INDICATORS: '20113005',
    LOAN_QUALITY: '20113006',
    SHOW_LEAD_PROVIDER: '20113007',
    CUSTOMER_TYPE: '20113009',
    SOURCE: '20113010',
    PERSONAL_SECTION: '20114001',
    EMPLOYMENT_SECTION: '20114002',
    BANK_INFO_SECTION: '20114003',
    BANK_RECORDS_SECTION: '20114004',
    LOAN_DETAILS_SECTION: '20114005',
    PAYMENT_SCHEDULE: '20114006',
    PAYMENT_PROGRESS: '20114007',
    DOCUMENT_FOLDER: '20114008',
    REQUEST_CASH_ADVANCE: '20210001',
    PAY_OFF: '20210002',
    PAY_OFF_IN_N: '20210003',
    PAY_DOWN: '20210004',
    CHANGE_MODE: '20210005',
    CHANGE_FREQUENCY: '20210006',
    CHANGE_DATE: '20210007',
    CHANGE_PAYDAY_ON_HOLIDAY: '20210008',
    CHANGE_PAYDAY_ON_AVAILABLE: '20210009',
    REVOKE_ACH: '20210010',
    MOVE_TO_COLLECTION: '20210011',
    ASSIGNED_MODE: '20210013',
    ASSIGNED_DATE: '20210014',
    ASSIGNED_AMOUNT: '20210012',
    ASSIGNED_SKIP: '20210015',
    MANUAL_REJECT: '20210017',
    MANUAL_CHECKED: '20210018',
    ASSIGNED_MAKEUP: '20210016',
    REFUND_PAYMENT: '20210019',
    REVERSE_DEBIT: '20210020',
    CANCEL: '20210021',
    MANUAL_VOID: '20210022',
    EDIT_PROFILE: '20210023',
    CANCEL_CHANGES: '20210024',
    PAID_OFF_EXPORT: '20210025',
    GOOD_STANDING_PAID_OFF_EXPORT: '20210026',
    WARNING_PAID_OFF_EXPORT: '20210027',
    MANUAL_PAID_OFF: '20210028',
    MANUAL_CLOSE: '20210029',
    ASSIGNED_MAKEUP_PARTIAL: '20210030',
    MANUAL_CHECKED_FOR_CREDIT: '20210031',
    REVOKE_WA: '20210032',
    SETTLEMENT_OPTION: '20210033',
    APPROVED_QUEUE: '20212001',
    NEW_QUEUE: '20212002',
    GOOD_STANDING_QUEUE: '20212003',
    PROCESSING_QUEUE: '20212004',
    WARNING_QUEUE: '20212005',
    GOOD_STANDING_PAID_OFF_QUEUE: '20212006',
    PAID_OFF_QUEUE: '20212007',
    WARNING_PAID_OFF_QUEUE: '20212008',
    VOIDED_QUEUE: '20212009',
    PENDING_APPROVED_QUEUE: '20212010',
    RESOLVED_QUEUE: '202120122',
    UNRESOLVED_QUEUE: '20212013',
    // LCS QUEUE
    PENDING_COLLECTION: '20312001',
    IN_HOUSE_COLLECTION: '20312002',
    PENDING_IN_HOUSE_APPROVE: '20312003',
    IN_HOUSE_REPLAN: '20312004',
    IN_HOUSE_SETTLEMENT: '20312005',
    PENDING_OUT_HOUSE_COLLECTION: '20312006',
    OUT_HOUSE_COLLECTION: '20312007',
    IN_HOUSE_REPLAN_PAID_OFF: '20312008',
    IN_HOUSE_SETTLEMENT_PAID_OFF: '20312009',
    IN_HOUSE_PAID_OFF_SETTLEMENT_QUEUE: '20312020',
    OUT_HOUSE_SETTLEMENT_QUEUE: '20312022',
    OUT_HOUSE_PAID_OFF: '20312010',
    IN_HOUSE_REJECTED: '20312011',
    OUT_HOUSE_REJECTED: '20312012',
    PENDING_BANKRUPTCY: '20312013',
    PENDING_CCCS: '20312014',
    PENDING_CANCELLATION: '20312015',
    BANKRUPTCY: '20312016',
    CCCS: '20312017',
    CANCELLATION: '20312018',
    MISCELLANEOUS: '20312019',
    // LCS DETAIL
    PAY_OFF_IN_N_LCS: '20310001',
    PAY_FIXED_AMOUNT: '20310002',
    MANUALLY_SETUP: '20310003',
    TO_COLLECTION: '20310004',
    CHANGE_PAYMENT_AMOUNT: '20310005',
    CHANGE_PAYMENT_MODE: '20310006',
    CHANGE_PAYMENT_DATE: '20310007',
    SKIP_PAYMENT: '20310008',
    MAKE_UP_PAYMENT: '20310009',
    MANUAL_REJECT_LCS: '20310010',
    MANUAL_CHECKED_LCS: '20310011',
    REFUND_PAYMENT_LCS: '20310012',
    REVERSE_DEBIT_LCS: '20310013',
    CANCEL_LCS: '20310014',
    MOVE_TO: '20310015',
    CONFIRM: '20310016',
    ADJUST_AMOUNT: '20310017',
    REQUEST_CASH_ADVANCE_IN_LCS: '20310018',
    VWA_TRACING: '20310019',
    EDIT_WAGE_ASSIGNMENT: '20310020',
    FRAUD_WARNING: '20310021',
    // PANDARIA
    OAM_SYSTEM: '30100001',
    BAMBOO_SYSTEM: '30200001',
    PANDA_SYSTEM: '30300001',
    SLOTH_SYSTEM: '30400001',
    FOX_SYSTEM: '30500001',
    EAGLE_SYSTEM: '30600001',
    ZEBRA_SYSTEM: '30700001',
    ANT_SYSTEM: '30800001',
    EXPRESS_LOAN: '20212011',
    HIGH_RISK_FILTER: '20010011'
  },
  DecisionLogicRequestCodeStatusEnum: {
    NOT_STARTED: { value: 0, text: 'Not Started' },
    STARTED: { value: 1, text: 'Started' },
    VERIFIED: { value: 3, text: 'Verified' },
    ACCOUNT_ERROR: { value: -1, text: 'Account Error' },
    BANK_ERROR: { value: -2, text: 'Bank Error' }
  },
  TransactionTypeEnum: {
    CREDIT: 14000,
    DEBIT: 14001,
    REFUND: 14002
  },
  StatusCode: {
    NEW_LOAN: 256,
    GOOD_STANDING: 1024,
    PENDING_COLLECTION: 536875008,
    VOIDED_LOAN: 512,
    PAID_OFF: 2048,
    APPROVED: 128
  },
  PaymentScheduleAction: {
    NORMAL: { text: 'Normal', value: 0 },
    PAY_OFF: { text: 'Pay Off', value: 101 },
    PAY_OFF_IN_N: { text: 'Pay Off In N Payments', value: 102 },
    PAY_DOWN: { text: 'Pay Down', value: 103 },
    REVOKE_ACH: { text: 'Revoke Future ACH', value: 104 },
    CHANGE_DATE: { text: 'Change Payroll Date', value: 105 },
    CHANGE_FREQUENCY: { text: 'Change Payroll Frequency', value: 106 },
    CHANGE_MODE: { text: 'Change Payment Mode', value: 107 },
    CHANGE_PAYDAY_ON_HOLIDAY: { text: 'Change Payday On Holiday', value: 108 },
    CHANGE_PAYDAY_ON_AVAILABLE: { text: 'Change Payday On Available', value: 109 },
    PAY_FIXED_AMOUNT: { text: 'Pay Fixed Amount', value: 111 },
    ADJUST_AMOUNT: { text: 'Adjust Amount', value: 112 },
    MANUALLY_SETUP: { text: 'Manually Setup', value: 110 },
    ASSIGNED_SKIP: { text: 'Skip Payment', value: 201 },
    ASSIGNED_MAKEUP: { text: 'Makeup Full Payment', value: 202 },
    ASSIGNED_AMOUNT: { text: 'Change Payment Amount', value: 203 },
    ASSIGNED_MODE: { text: 'Change Payment Mode', value: 204 },
    ASSIGNED_DATE: { text: 'Change Payment Date', value: 205 },
    ASSIGNED_MAKEUP_PARTIAL: { text: 'Make Up Partial Payment', value: 206 },
    REFUND_CREDIT: { text: 'Reverse Credit', value: 301 },
    REVERSE_DEBIT: { text: 'Reverse Debit', value: 302 },
    REFUND_BANK_FEE: { text: 'Refund Bank Fee', value: 303 },
    REFUND_FULL_PAYMENT: { text: 'Refund Full Payment', value: 304 },
    REFUND_PARTIAL_PAYMENT: { text: 'Refund Partial Payment', value: 305 },
    REFUND_PAYMENT: { text: 'Refund Payment', value: 306 },
    MANUAL_REJECT: { text: 'Manual Reject', value: 901 },
    CANCEL_CHANGE: { text: 'Cancel Changes', value: 902 },
    MANUAL_CHECKED: { text: 'Manual Checked', value: 903 },
    COLLECTION_SINGLE_CANCEL: { text: 'Cancel', value: 9527 },
    REVOKE_WA: { text: 'Revoke WA', value: 904 }
  },
  LoanTypeConst: {
    INSTALLMENT_LOAN: 82010101,
    CREDIT_LINE_LOAN: 82010102,
    MULTIPLE_ADVANCE_LOAN: 82010103,
    SLAVE_LOAN: 82010199
  },
  AuthorizationTypeEnum: {
    LOAN_AGREEMENT: { value: 1, text: 'Loan Agreement' },
    TELEPHONE: { value: 2, text: 'Telephone' },
    EMAIL: { value: 3, text: 'Email' },
    TEXT: { value: 4, text: 'Text' },
    WEBSITE: { value: 5, text: 'Website' },
    ONLINE_CHAT: { value: 6, text: 'Online Chat' },
    OTHER: { value: 7, text: 'Other' },
    CUSTOMER_SELF_SERVICE: { value: 8, text: 'Customer Self Service' }
  },
  FlagsEnum: {
    DEFAULT: 0,
    DELETED: 1 << 0,
    FULL_REFUNDED: 1 << 1,
    CANCEL: 1 << 2,
    COLLECTION: 1 << 3,
    PARTIAL_REFUND: 1 << 4,
    PARTIAL_MAKEUP: 1 << 5,
    NEW: 1 << 8
  },
  LoanWorkQueueSortEnum: {
    CREATED_AT_DESC: { value: 1, text: 'Created At Desc' },
    CREATED_AT_ASC: { value: 2, text: 'Created At Asc' },
    UPDATED_AT_DESC: { value: 3, text: 'Updated At Desc' },
    UPDATED_AT_ASC: { value: 4, text: 'Updated At Asc' }
  },
  LoanActionEnum: {
    EXPRESS: { value: 2001, text: 'EXPRESS' },
    LOAN_TRANSFER: { value: 2002, text: 'LOAN_TRANSFER' },
    RFE: { value: 2003, text: 'RFE' },
    WITHDRAW: { value: 2004, text: 'WITHDRAW' },
    RELOAD: { value: 2005, text: 'RELOAD' },
    UNLOCK: { value: 2006, text: 'UNLOCK' },
    GRAB_LOCK: { value: 2007, text: 'GRAB_LOCK' },
    CHANGE_STATUS: { value: 2008, text: 'CHANGE_STATUS' },
    LOCK: { value: 2009, text: 'LOCK' },
    FOLLOW_UP: { value: 2010, text: 'FOLLOW_UP' },
    GRAB_ACCEPT: { value: 2011, text: 'GRAB_ACCEPT' },
    GRAB_REJECT: { value: 2012, text: 'GRAB_REJECT' },
    GRAB_REQUEST: { value: 2013, text: 'GRAB_REQUEST' },
    CHANGE_SIGNATURE_STATUS: { value: 2014, text: 'CHANGE_SIGNATURE_STATUS' },
    EXECUTE_INTEGRATED_COMPUTATION: { value: 2015, text: 'Execute Integrated Computation' },
    REOPEN_STAMP: { value: 2016, text: 'Reopen Stamp' },
    MLA_VERIFY: { value: 2018, text: 'MLA verify' },
    LA_RECOVER: { value: 2019, text: 'LA Recover' },
    INSTANT_LITIGANT_VERIFICATION: { value: 2020, text: 'Instant Litigant Verification' },
    SIGN_OUT: { value: 2999, text: 'Sign Out' },
    UPDATE_LOAN_FLAGS_JARVIS: { value: 4, text: 'Update Loan Flags for Jarvis' },
    UPDATE_LOAN_FLAGS_FOX_V4: { value: 5, text: 'Update Loan Flags For Fox V4' }
  },
  ApplicationWorkQueueSortEnum: {
    CREATED_AT_DESC: { value: 1, text: 'Created At Desc' },
    CREATED_AT_ASC: { value: 2, text: 'Created At Asc' },
    UPDATED_AT_DESC: { value: 3, text: 'Updated At Desc' },
    UPDATED_AT_ASC: { value: 4, text: 'Updated At Asc' }
  },
  DialogActionEnum: {
    HIDE: 0,
    DISPLAY: 1,
    OPERATE: 2
  },
  ErrorCode: {
    SUCCESS: 1,
    DEFAULT: 0,
    FAILURE: -1
  },
  CalculateResultFlag: {
    DEFAULT: { value: 0, text: 'Default' },
    SUCCESS: { value: 1, text: 'Calculate Success' },
    CLEAR_LOAN_AMOUNT: { value: 2, text: 'Clear Loan Amount And Payment Schedule' },
    CLEAR_PAYMENT_SCHEDULE: { value: 3, text: 'Clear Payment Schedule' }
  },
  TribeDeny: [
    { text: 'Denied by Tribe-Elevated concern', value: 20021 },
    { text: 'Denied by Tribe-General guidelines', value: 20022 }
  ],
  TimeZoneTypeEnum: {
    SERVER_SIDE: { value: 88010201, text: 'Server Side Timezone' },
    CUSTOMER_SIDE: { value: 88010202, text: 'Customer Side Timezone' }
  },
  GenerateFileStatusEnum: {
    GENERATE_FAILED: { value: -2, text: 'Failed to generate file' },
    DELETE_FILE: { value: -1, text: 'Delete File' },
    BEING_GENERATED: { value: 0, text: 'File is being generated' },
    SUCCESS: { value: 1, text: 'Success' }
  },
  AjaxResultCodeEnum: {
    FAILURE_USER_INFO_INVALID: { value: -83010050, text: 'Lack of user information' },
    INVALID_USER_INFORMATION: { value: -83050201, text: 'Invalid user information.' },
    GET_ACCOUNT_FAILURE_OAUTH_KEY_DOES_NOT_EXISTS: { value: -8102071, text: 'Get account failure, auth key does not exists.' },
    GET_AUTHORIZATION_FAILURE_OAUTH_KEY_DOES_NOT_EXISTS: { value: -8102081, text: 'Get authorization failure, auth key does not exists.' },
    GENERATE_IN_SHORT_TIME: { value: -83010018, text: 'Generate Failed: generate in short time' }
  },
  PaymentFeeTypeEnum: {
    UNKNOWN: { value: -1, text: 'Unknown' },
    TOTAL: { value: 1, text: 'TOTAL' },
    PAID_IN_PROCESS: { value: 2, text: 'PROCESS_PAID_FEE' },
    LEFT_IN_PROCESS: { value: 3, text: 'PROCESS_LEFT_FEE' },
    WAIVED_IN_PROCESS: { value: 4, text: 'PROCESS_WAIVED_FEE' },
    PAID_IN_COLLECTION: { value: 5, text: 'COLLECTION_PAID_FEE' },
    LEFT_IN_COLLECTION: { value: 6, text: 'COLLECTION_LEFT_FEE' },
    WAIVED_IN_COLLECTION: { value: 7, text: 'COLLECTION_WAIVED_FEE' },
    DISCOUNT: { value: 8, text: 'DISCOUNT_FEE' },
    LEFT_REFUND_FEE: { value: 9, text: 'LEFT_REFUND_FEE' },
    PAID_REFUND_FEE: { value: 10, text: 'PAID_REFUND_fEE' },
    WAIVED_REFUND_FEE: { value: 11, text: 'WAIVED_REFUND_FEE' },
    // record fee
    ORIGINAL_IN_COLLECTION: { value: 100, text: 'ORIGINAL_IN_COLLECTION' },
    ORIGINAL_IN_WA: { value: 101, text: 'ORIGINAL_IN_WA' },
    ADDITIONAL_IN_WA: { value: 102, text: 'ADDITIONAL_IN_WA' },
    ORIGINAL_REFUND_FEE: { value: 104, text: 'ORIGINAL_REFUND_FEE' },
    COLLECTION_REFUND_BALANCE: { value: 105, text: 'COLLECTION_REFUND_BALANCE' },
    // display fee
    COLLECTION_BALANCE: { value: 201, text: 'COLLECTION_BALANCE' },
    TOTAL_AMOUNT_PAID: { value: 202, text: 'TOTAL_AMOUNT_PAID' }
  },
  SocketReadyStateEnum: {
    ON_OPEN: { value: 0, text: 'On open' },
    READY: { value: 1, text: 'Ready' },
    ON_CLOSE: { value: 2, text: 'On close' },
    CLOSE: { value: 3, text: 'Close' }
  },
  InstallmentFlagEnum: {
    // 初始状态
    DEFAULT: { value: 0, text: 'Default' },
    // 废弃状态
    DELETED: { value: 1, text: 'Deleted' },
    // refunded状态(单期付款操作时refunded分期标志)
    FULL_REFUND: { value: 1 << 1, text: 'Full Refund' },
    // cancel状态(分期付款操作后是否允许cancel操作)
    CANCEL: { value: 1 << 2, text: 'Cancel' },
    // collection状态(进去collect系统的分期付款)
    COLLECTION: { value: 1 << 3, text: 'Collection' },
    // collection状态(进去collect系统的分期付款)
    PARTIAL_REFUND: { value: 1 << 4, text: 'Partial Refund' },
    // 新增状态(新增加的单期付款)
    NEW: { value: 1 << 8, text: 'New' },
    // only for shift XOR operation
    SHIFT: { value: 1 << 9, text: 'Shift' }
  },
  FrozenStatusEnum: {
    ENABLE: { value: 1, text: 'Enable' },
    DISABLE: { value: -1, text: 'Disable' }
  },
  LoanSectionKey: {
    PERSONAL: 'personal',
    EMPLOYMENT: 'employment',
    BANKING: 'banking',
    STATEMENT: 'statement',
    PAYMENT_OPTION: 'paymentOption',
    DOCUMENT: 'document'
  },
  StampReasonEnum: {
    /* Personal Stamp Reason */
    PERSONAL_ALL_VERIFIED: { value: 71101, text: 'Verified all personal information', type: 7001, sectionKey: 'personal' },
    PERSONAL_REMOTE_CONSENT: { value: 71102, text: 'Remote Consent Customer', type: 7001, sectionKey: 'personal' },
    PERSONAL_ONLINE_PROGRAM: { value: 71103, text: 'Online Program Action', type: 7001, sectionKey: 'personal' },
    PERSONAL_PARTIALLY_VERIFIED: { value: 71201, text: 'Partially verified', type: 7002, sectionKey: 'personal' },
    PERSONAL_NOT_VERIFIED: { value: 71301, text: 'Not yet verified', type: 7003, sectionKey: 'personal' },
    PERSONAL_DECLINE: { value: 71401, text: 'Personal declined', type: 7004, section: 'personal' },
    PERSONAL_REOPEN: { value: 71501, text: 'Reopen Stamp', type: 7005, section: 'personal' },

    /* Employment Stamp Reason */
    EMPLOYMENT_VERIFIED_BY_DD: { value: 72101, text: 'Verified via DDs', type: 7001, sectionKey: 'employment' },
    EMPLOYMENT_VERIFIED_REGULAR: { value: 72102, text: 'Regular VOE', type: 7001, sectionKey: 'employment' },
    EMPLOYMENT_VERIFIED_STRONG: { value: 72103, text: 'Strong VOE', type: 7001, sectionKey: 'employment' },
    EMPLOYMENT_ONLINE_PROGRAM: { value: 72104, text: 'Online Program Action', type: 7001, sectionKey: 'employment' },
    EMPLOYMENT_NOT_VERIFIED: { value: 72301, text: 'VOE not performed yet', type: 7003, sectionKey: 'employment' },
    EMPLOYMENT_DECLINE: { value: 72401, text: 'Employment declined', type: 7004, section: 'employment' },
    EMPLOYMENT_REOPEN: { value: 72501, text: 'Reopen Stamp', type: 7005, section: 'employment' },

    /* Bank Stamp Reason */
    BANKING_VERIFIED_BY_CALL: { value: 73101, text: 'Verified via conference call', type: 7001, sectionKey: 'banking' },
    BANKING_VERIFIED_BY_DL: { value: 73102, text: 'Verified via Decision Logic', type: 7001, sectionKey: 'banking' },
    BANKING_ONLINE_PROGRAM: { value: 73103, text: 'Online Program Action', type: 7001, sectionKey: 'banking' },
    BANKING_PARTIALLY_VERIFIED: { value: 73201, text: 'Partially verified, still not completed', type: 7002, sectionKey: 'banking' },
    BANKING_NOT_VERIFIED: { value: 73301, text: 'Not yet verified', type: 7003, sectionKey: 'banking' },
    BANKING_DECLINE: { value: 73401, text: 'Banking declined', type: 7004, section: 'banking' },
    BANKING_REOPEN: { value: 73501, text: 'Reopen Stamp', type: 7005, section: 'banking' },

    /* Payment Option Reason */
    PAYMENT_OPTION_EXPLANATION_IS_COMPLETED: { value: 74101, text: 'Explanation of payment options completed', type: 7001, sectionKey: 'paymentOption' },
    PAYMENT_OPTION_ADDITIONAL_EXPLANATION: { value: 74102, text: 'Customer requested additional payment option', type: 7001, sectionKey: 'paymentOption' },
    PAYMENT_OPTION_EXPLANATION_IS_EXPIRED: { value: 74103, text: 'The first payment option explanation expired', type: 7001, sectionKey: 'paymentOption' },
    PAYMENT_ONLINE_PROGRAM: { value: 74104, text: 'Online Program Action', type: 7001, sectionKey: 'paymentOption' },
    PAYMENT_OPTION_NOT_COMPLETED: { value: 74301, text: 'Explanation of payment options still not performed', type: 7003, sectionKey: 'paymentOption' },
    PAYMENT_DECLINE: { value: 74401, text: 'Payment declined', type: 7004, section: 'paymentOption' },
    PAYMENT_REOPEN: { value: 74501, text: 'Reopen Stamp', type: 7005, section: 'paymentOption' },

    /* Document Reason */
    DOCUMENT_AUTO_STAMP: { value: 75101, text: 'Auto stamp for document', type: 7001, sectionKey: 'document' }
  },
  StampActionTypeEnum: {
    POSITIVE_STAMP: { value: 7001, text: 'Positive Stamp', icon: 'check_circle', color: 'success' },
    PENDING_STAMP: { value: 7002, text: 'Pending Stamp', icon: 'pending', color: 'warning' },
    NEGATIVE_STAMP: { value: 7003, text: 'Negative Stamp', icon: 'cancel', color: 'error' },
    DECLINE_STAMP: { value: 7004, text: 'Decline Stamp', icon: 'error', color: 'error' },
    REOPEN_STAMP: { value: 7005, text: 'Reopen Stamp', icon: 'check_circle', color: 'success' }
  },
  EmailTemplateTypeEnum: {
    LOAN_AGREEMENT: { value: 1, text: 'Loan Agreement', templateCode: '' },
    PAYMENT_OPTIONS: { value: 2, text: 'Payment Options', templateCode: 'AL-2-1' },
    BANK_VERIFICATION_PROCESS: { value: 3, text: 'Bank Verification Process', templateCode: 'BSR-001' },
    NOAA_NOTIFICATION: { value: 4, text: 'NOAA Notification', templateCode: 'NOAA-3' },
    LOAN_APPROVED: { value: 5, text: 'Loan Approved', templateCode: 'AL-1' },
    PENDING_STATUS: { value: 7, text: 'Pending Status', templateCode: 'PAFU-1' },
    COMPLETE_LOAN_PROCESS: { value: 8, text: 'Complete Loan Process', templateCode: 'PAFU-2' },
    MORE_INFORMATION: { value: 9, text: 'More information is needed', templateCode: 'PAFU-3' },
    LOAN_CANCELLATION: { value: 10, text: 'Loan Cancellation', templateCode: 'TBW-1' }
  },
  IndicatorEnum: {
    BANKRUPTCIES: { value: 20101, text: 'Bankruptcies', key: 'BANKRUPTCIES' },
    LIENS: { value: 20102, text: 'Liens', key: 'LIENS' },
    JUDGMENTS: { value: 20103, text: 'Judgments', key: 'JUDGMENTS' },
    UTILITIES: { value: 20104, text: 'Utilities', key: 'UTILITIES' },
    HIGH_RISK: { value: 20105, text: 'High Risk', key: 'HIGH_RISK' },
    SSN: { value: 20106, text: 'SSN', key: 'SSN' },
    NAMES: { value: 20107, text: 'Names', key: 'NAMES' },
    EMAILS: { value: 20108, text: 'Emails', key: 'EMAILS' },
    PHONES: { value: 20109, text: 'Phones', key: 'PHONES' },
    DOB: { value: 20110, text: 'DOB', key: 'DOB' }
  },
  AnswerEnum: {
    YES: { value: 101, text: 'yes' },
    NO: { value: 102, text: 'no' },
    NEXT_BUSINESS_DAY: { value: 103, text: 'next business day' },
    SAME_DAY: { value: 104, text: 'same day' }
  },
  RoleEnum: {
    ORIGINATION_AGENT: { text: 'Origination Agent', code: 'ORIGINATION_AGENT' },
    ORIGINATION_AGENT_OUTBOUND: { text: 'Origination Agent Outbound', code: 'ORIGINATION_AGENT_OUTBOUND' },
    CORRECTION_AGENT: { text: 'Correction Agent', code: 'CORRECTION_AGENT' },
    RETENTION_AGENT: { text: 'Retention Withdrawn Agent', code: 'RETENTION_AGENT' },
    RETENTION_CUSTOMER_POC: { text: 'Retention Customer POC', code: 'RCP' },
    RETURNING_AGENT: { text: 'Returning Agent', code: 'RETURNING_AGENT' },
    RETURNING_CUSTOMER_SUPERVISOR: { text: 'Retention Customer Supervisor', code: 'RETURNING_CUSTOMER_SUPERVISOR' },
    RETURNING_CUSTOMER_POC: { text: 'Returning Customer POC', code: 'RETURNING_CUSTOMER_POC' },
    COLLECTION_AGENT: { text: 'Collection Agent', code: 'COLLECTION_AGENT' },
    RESOLUTIONS_DEPARTMENT_AGENT: { text: 'Resolutions Department Agent', code: 'RESOLUTIONS_DEPARTMENT_AGENT' },
    RESOLUTIONS_DEPARTMENT_MANAGER: { text: 'Resolutions Department Manager', code: 'RESOLUTIONS_DEPARTMENT_MANAGER' },
    SUPPORT_AGENT: { text: 'Support Agent', code: 'SUPPORT_AGENT' },
    SUPPORT_SUPERVISOR: { text: 'Support Supervisor', code: 'SUPPORT_SUPERVISOR' },
    SUPPORT_MANAGER: { text: 'Support Manager', code: 'SUPPORT_MANAGER' },
    PRODUCTION_MANAGER: { text: 'Production Manager', code: 'PRODUCTION_MANAGER' },
    PRODUCTION_MANAGER_ADMIN: { text: 'Production Manager Admin', code: 'PRODUCTION_MANAGER_ADMIN' },
    ORIGINATION_SUPERVISOR: { text: 'Origination Supervisor', code: 'ORIGINATION_SUPERVISOR' },
    OPERATIONS_SUPERVISOR_POC: { text: 'Operations Supervisor POC', code: 'OPERATIONS_SUPERVISOR_POC' },
    ORIGINATION_SUPERVISOR_DISPUTE_POC: { text: 'Origination Supervisor Dispute POC', code: 'ORIGINATION_SUPERVISOR_DISPUTE_POC' },
    ORIGINATION_MANAGER: { text: 'Origination Manager', code: 'ORIGINATION_MANAGER' },
    CORRECTION_SUPERVISOR: { text: 'Correction Supervisor', code: 'CORRECTION_SUPERVISOR' },
    CORRECTION_MANAGER: { text: 'Correction Manager', code: 'CORRECTION_MANAGER' },
    COLLECTION_SUPERVISOR: { text: 'Collection Supervisor', code: 'COLLECTION_SUPERVISOR' },
    COLLECTION_MANAGER: { text: 'Collection Manager', code: 'COLLECTION_MANAGER' },
    CHAT_AGENT: { text: 'Chat Agent', code: 'CHAT_AGENT' },
    ADMINISTRATOR: { text: 'Administrator', code: 'ADMINISTRATOR' },
    WAI_AGENT: { text: 'WAI Agent', code: 'WAI_AGENT' },
    TRIBE_AGENT: { text: 'Tribe Agent', code: 'TRIBAL_LOAN_CLOSING_OFFICERS' },
    TRIBE_SUPERVISOR: { text: 'Tribe Supervisor', code: 'TRIBAL_SUPERVISOR' },
    TRIBE_QUALITY_ASSURANCE: { text: 'Tribe Quality Assurance', code: 'TRIBAL_COMPLIANCE_OFFICER/TRIBAL_QUALITY_ASSURANCE' },
    UNDERWRITER_MANAGER: { text: 'UnderWriter Manager', code: 'APPLICATION_REVIEW_MANAGER' },
    UNDERWRITER_SUPERVISOR: { text: 'UnderWriter Supervisor', code: 'APPLICATION_REVIEW_SUPERVISOR' },
    UNDERWRITER_AGENT: { text: 'UnderWriter Agent', code: 'APPLICATION_REVIEW_AGENT' }
  },
  RoleIdEnum: {
    ADMINISTRATOR: { text: 'Administrator', value: 16 },
    ORIGINATION_AGENT: { text: 'Origination Agent', value: 19 },
    ORIGINATION_SUPERVISOR: { text: 'Origination Supervisor', value: 20 },
    CORRECTION_AGENT: { text: 'Correction Agent', value: 21 },
    CORRECTION_SUPERVISOR: { text: 'Correction Supervisor', value: 22 },
    UNDERWRITER_AGENT: { text: 'UnderWriter Agent', value: 23 },
    UNDERWRITER_SUPERVISOR: { text: 'UnderWriter Supervisor', value: 24 },
    SUPPORT_AGENT: { text: 'Support Agent', value: 27 },
    PRODUCTION_MANAGER: { text: 'Production Manager', value: 34 },
    RETURNING_AGENT: { text: 'Returning Agent', value: 43 },
    RETURNING_CUSTOMER_POC: { text: 'Returning Customer POC', value: 46 },
    RETENTION_CUSTOMER_SUPERVISOR: { text: 'Retention Customer Supervisor', value: 47 },
    PRODUCTION_MANAGER_ADMIN: { text: 'Production Manager Admin', value: 49 },
    RETURNING_CUSTOMER_SUPERVISOR: { text: 'Returning Customer Supervisor', value: 56 }
  },
  QueueTypeEnum: {
    ApplicationQueue: { value: 1, text: 'Application Queue' },
    SpecialQueue: { value: 2, text: 'Special Queue' },
    ComplaintQueue: { value: 3, text: 'Complaint Queue' }
  },
  LoanSourceEnum: {
    PURCHASE: { value: 1 << 0, text: 'Purchase' },
    RETURNING: { value: 1 << 1, text: 'Returning' },
    EXPRESS: { value: 1 << 2, text: 'Express' },
    TRANSFER: { value: 1 << 3, text: 'Loan Transfer' },
    MARKET: { value: 1 << 4, text: 'Market' },
    VOIDED: { value: 1 << 5, text: 'Voided' },
    ORGANIC: { value: 1 << 6, text: 'Organic' },
    VERTICAL: { value: 1 << 30, text: 'Vertical' }
  },
  transactionProvider: {
    LPP_DEBIT_CARD_PAY_DIT_PROVIDER: { value: 77, text: 'LPP_Debit_Card' },
    VIKING_DEBIT_CARD_PAY_DIT_PROVIDER: { value: 88, text: 'Viking_Debit_Card' }
  },
  LeadStatusEnum: {
    ACCEPT: { value: 1, text: 'Accept' },
    REFRESH: { value: 2, text: 'Refresh' },
    REJECT: { value: -1, text: 'Reject' },
    ERROR: { value: -2, text: 'Error' }
  },
  LoanVersion: {
    V2_LOAN: 1,
    V3_LOAN: 2,
    VERTICAL: 3
  },
  LeadFilterTypeEnum: {
    HARD_FILTER: { value: 101, text: 'Hard Filter' },
    SOFT_FILTER: { value: 102, text: 'Soft Filter' },
    WHITE_LIST_FILTER: { value: 103, text: 'White List Filter' },
    COMPLAINT_FILTER: { value: 104, text: 'Complaint Filter' },
    RISK_FILTER: { value: 105, text: 'Risk Filter' }
  },
  states: [
    { value: 'EQ', text: 'EQUAL' },
    { value: 'NEQ', text: 'NOT EQUAL' },
    { value: 'LT', text: 'LESS THAN' },
    { value: 'LTEQ', text: 'LESS THAN OR EQUAL' },
    { value: 'GT', text: 'GREATER THAN' },
    { value: 'GTEQ', text: 'GREATER THAN OR EQUAL' },
    { value: 'IN', text: 'IN' },
    { value: 'NIN', text: 'NOT IN' },
    { value: 'CT', text: 'CONTAIN' },
    { value: 'NCT', text: 'NOT CONTAIN' },
    { value: 'BW', text: 'BEGIN WITH' },
    { value: 'NBW', text: 'NOT BEGIN WITH' },
    { value: 'EW', text: 'END WITH' },
    { value: 'NEW', text: 'NOT END WITH' },
    { value: 'LENGTHEQ', text: 'LENGTH EQ' }
  ],
  statesValue: [
    { value: 10007, text: 'IN' },
    { value: 10001, text: 'EQUAL' },
    { value: 10002, text: 'NOT EQUAL' },
    { value: 10003, text: 'LESS THAN' },
    { value: 10004, text: 'LESS THAN OR EQUAL' },
    { value: 10005, text: 'GREATER THAN' },
    { value: 10006, text: 'GREATER THAN OR EQUAL' },
    { value: 10008, text: 'NOT IN' },
    { value: 10009, text: 'CONTAIN' },
    { value: 10010, text: 'NOT CONTAIN' },
    { value: 10011, text: 'BEGIN WITH' },
    { value: 10012, text: 'NOT BEGIN WITH' },
    { value: 10013, text: 'END WITH' },
    { value: 10014, text: 'NOT END WITH' },
    { value: 10015, text: 'LENGTH EQ' }
  ],
  BlacklistEnum: {
    EMAIL: 'email',
    SSN: 'ssn',
    STATE: 'state',
    ACCOUNT_NUMBER: 'accountnumber',
    ROUTING_NUMBER: 'routingnumber',
    PERSONAL_NAME: 'personalName',
    EMPLOYMENT_NAME: 'employmentName',
    ZIP: 'zip',
    BIRTHDAY: 'birthday'
  },
  WarningListEnum: {
    ZIP: 'zip',
    EMAIL: 'email',
    LAST_PAY_DAY: 'lastPayday'
  },
  LoanFlagsEnum: {
    NORMAL: { value: 1 << 0, text: 'Normal' },
    IMPORTED: { value: 1 << 1, text: 'Imported' },
    EXPRESSED: { value: 1 << 2, text: 'Expressed' },
    TRANSFERRED: { value: 1 << 3, text: 'Transferred' },
    AUTO: { value: 1 << 4, text: 'Auto' },
    PARTIAL_MAKEUP: { value: 1 << 5, text: 'Partial Makeup' },
    FULL_MAKEUP: { value: 1 << 6, text: 'Full Makeup' },
    DO_NOT_LEND: { value: 1 << 7, text: 'Do not lend' },
    INSTANT_FUND: { value: 1 << 8, text: 'Instant Fund' },
    STRICT: { value: 1 << 9, text: 'Strict' },
    CROSS_PORTFOLIO_GOOD: { value: 1 << 10, text: 'Cross Portfolio Good' },
    OVERFLOW: { value: 1 << 11, text: 'Overflow' },
    RETURNED_CREDIT: { value: 1 << 12, text: 'Returned Credit' },
    DISBURSEMENT_OVERFLOW: { value: 1 << 13, text: 'Disbursement Overflow' },
    REPAYMENT_OVERFLOW: { value: 1 << 14, text: 'Repayment Overflow' },
    PRINCIPAL_DISCOUNT: { value: 1 << 15, text: 'Principal Discount' },
    RUN_TIME_TRANSACTION: { value: 1 << 16, text: 'Run Time Transaction' },
    REVOKE_ACH: { value: 1 << 17, text: 'Revoke Ach' },
    PIGEON_MARKETING: { value: 1 << 18, text: 'Pigeon Marketing' },
    JARVIS: { value: 1 << 19, text: 'Jarvis' },
    FOX_EXPRESS: { value: 1 << 21, text: 'Fox Express' },
    MILITARY: { value: 1 << 23, text: 'Military' }
  },
  TaskTypeEnum: {
    // ACH 相关的task操作
    ACH_SEND_DEBIT_TASK: { value: 150001001, text: 'ACH_SEND_DEBIT_TASK' },
    ACH_SEND_CREDIT_TASK: { value: 150001002, text: 'ACH_SEND_CREDIT_TASK' },
    ACH_SEND_REFUND_TASK: { value: 150001003, text: 'ACH_SEND_REFUND_TASK' },
    ACH_RETURN_TASK: { value: 150002001, text: 'ACH_RETURN_TASK' },
    ACH_CHECK_TASK: { value: 150003001, text: 'ACH_CHECK_TASK' },
    ACH_OVERRIDE_TASK: { value: 150004001, text: 'ACH_OVERRIDE_TASK' },
    ACH_EXPIRED_TASK: { value: 150005001, text: 'ACH_EXPIRED_TASK' },
    // External 相关的task操作
    EXTERNAL_TRANSFER_TASK_FOR_WA: { value: 150121001, text: 'EXTERNAL_TRANSFER_TASK_FOR_WA' },
    EXTERNAL_TRANSFER_TASK_FOR_WAI: { value: 150121002, text: 'EXTERNAL_TRANSFER_TASK_FOR_WAI' },
    EXTERNAL_CHECK_TASK_FOR_WA: { value: 150122001, text: 'EXTERNAL_CHECK_TASK_FOR_WA' },
    EXTERNAL_REJECT_TASK_FOR_WA: { value: 150122002, text: 'EXTERNAL_REJECT_TASK_FOR_WA' },
    EXTERNAL_CHECK_TASK_FOR_WAI: { value: 150122003, text: 'EXTERNAL_CHECK_TASK_FOR_WAI' },
    EXTERNAL_REJECT_TASK_FOR_WAI: { value: 150122004, text: 'EXTERNAL_REJECT_TASK_FOR_WAI' },
    EXTERNAL_PAID_OFF_TASK_FOR_WA: { value: 150123001, text: 'EXTERNAL_PAID_OFF_TASK_FOR_WA' },
    EXTERNAL_PAID_OFF_TASK_FOR_WAI: { value: 150123002, text: 'EXTERNAL_PAID_OFF_TASK_FOR_WAI' },
    // INSTANT FUND 相关的task操作
    INSTANT_FUND_TRANSACTION_TASK: { value: 150145001, text: 'INSTANT_FUND_TRANSACTION_TASK' },
    // 不和 Transaction Mode 相关的task操作
    MANUALLY_CHECK_TASK: { value: 83061001, text: 'MANUALLY_CHECK_TASK' },
    MANUALLY_REJECT_TASK: { value: 83061002, text: 'MANUALLY_REJECT_TASK' },
    AUTO_RETURN_FOR_NON_ACH_TRANSACTIONS: { value: 83062001, text: 'AUTO_RETURN_FOR_NON_ACH_TRANSACTIONS' },
    THIRD_PARTY_TASK: { value: 83063001, text: 'THIRD_PARTY_TASK' },
    EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT: { value: 150124001, text: 'External Transfer Task For Pay Dit' },
    EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT: { value: 150124002, text: 'External Plan Create Task For Pay Dit' },
    EXTERNAL_CHECK_TASK_FOR_PAY_DIT: { value: 150124003, text: 'EXTERNAL_CHECK_TASK_FOR_PAY_DIT' },
    EXTERNAL_NEW_BALANCE: { value: 150125001, text: 'EXTERNAL_NEW_BALANCE' }
  },
  WAReturnTypeEnum: {
    PAYMENT: { value: 1, text: 'Payment File' },
    REJECT: { value: 2, text: 'Rejected File' },
    PAID_OFF: { value: 3, text: 'Paid Off File' }
  },
  LastPaymentDate: [
    { value: -1, text: 'Last Debit Date' },
    { value: 1, text: 'Contract deadline' }
  ],
  LastPaymentDateEnum: {
    LAST_DEBIT_DATE: { value: -1, text: 'Last Debit Date' },
    CONTRACT_DEADLINE: { value: 1, text: 'Contract deadline' }
  },
  ButtonEnum: {
    ERROR: { value: 70000, text: 'Error' },
    PAY_OFF_IN_N: { value: 70001, text: 'Pay Off In N.' },
    PAY_FIXED_AMOUNT: { value: 70002, text: 'Pay Fixed Amount.' },
    MANUALLY_SET_UP: { value: 70003, text: 'Manually Set Up.' },
    REQUEST_CASH_ADVANCE: { value: 70004, text: 'Request Cash Advance.' },
    MOVE_TO: { value: 70005, text: 'Move To.' },
    CONFIRM: { value: 70006, text: 'Confirm.' },
    PAID_OFF: { value: 70007, text: 'Paid Off.' },
    ADJUST_AMOUNT: { value: 70008, text: 'Adjust amount' },
    CLOSE: { value: 70009, text: 'Close' },
    REVOKE_WA: { value: 70010, text: 'Revoke WA' }
  },
  RouterPath: {
    LOS_PATH: '/pre-origination/application',
    PPS_PATH: '/post-origination/application/',
    LCS_PATH: '/collection/application/'
  },
  EmailQueryType: {
    NOT_SENT_YET: { value: -1, text: 'NOT_SENT_YET' },
    SENDING: { value: 0, text: 'SENDING' },
    SENT_SUCCESSFULLY: { value: 1, text: 'SENT_SUCCESSFULLY' },
    NEED_TO_GENERATE: { value: 2, text: 'NEED_TO_GENERATE' }
  },
  EmailTypeEnum: {
    WA_EMAIL_TYPE: { value: 50001, text: 'Send Email for WA.' },
    EMPLOYER_EMAIL_TYPE: { value: 50002, text: 'Send Email for Employer.' }
  },
  FaxTypeEnum: {
    SEND_FAX_TO_EMPLOYER: { value: 10001, text: 'Send Fax To Employer' }
  },
  CollectionProviderEnum: {
    NA: { value: -1, text: 'N/A' },
    VULTURE: { value: 10001, text: 'Vulture' },
    WAGE_ASSIGNMENT: { value: 20001, text: 'Wage Assignment External' },
    WAGE_ASSIGNMENT_IN_HOUSE: { value: 20002, text: 'Wage Assignment In House' },
    THIRD_PARTY: { value: 20003, text: 'Third Party' },
    EXTERNAL_UPDATE_STATUS_TASK_FOR_PAY_DIT: { value: 150124001, text: 'External Transfer Task For Pay Dit' },
    EXTERNAL_PLAN_CREATE_TASK_FOR_PAY_DIT: { value: 150124002, text: 'External Plan Create Task For Pay Dit' },
    BALANCE_UPDATE_UPLOADER: { value: 150104004, text: 'Balance Update Uploader' }
  },
  Portfolio: [
    { value: 1, text: 'Inbox Loan', code: 'IL' },
    { value: 2, text: 'Next Loan', code: 'NL' },
    { value: 3, text: 'First Loan', code: 'FL' },
    { value: 4, text: 'Better Day Loans', code: 'BDL' },
    { value: 5, text: 'Comet Loan', code: 'CL' },
    { value: 6, text: 'Inbox Credit', code: 'IC' },
    { value: 7, text: 'West Side Lending', code: 'WSL' },
    { value: 8, text: 'East Line Lending', code: 'ELL' },
    { value: 10, text: 'Right Now Loan', code: 'RNL' },
    // { value: 60, text: 'Saved By Cash', code: 'SBC' },
    { value: 61, text: 'Post Lake Lending', code: 'PLL' },
    { value: 62, text: 'Northern Star Lending', code: 'NSL' },
    { value: 64, text: 'Night Winds Lending', code: 'NWL' }
  ],
  Languages: [
    { value: 100, text: 'All' },
    { value: 101, text: 'English' },
    { value: 102, text: 'Spanish' }
  ],
  VipSettings: [
    { value: -1, text: 'Off' },
    { value: 1, text: 'On' },
    { value: 0, text: 'All' }
  ],
  ConsentSettings: [
    { value: -1, text: 'Off' },
    { value: 1, text: 'On' },
    { value: 0, text: 'All' }
  ],
  NotificationTab: {
    WA_NEED_TO_SEND: 'Need To Send (WAE)',
    WA_SENDING: 'Sending (WAE)',
    WA_SUCCESSFULLY: 'Successfully (WAE)',
    WAI_NEED_TO_SEND: 'Need To Send (WAI)',
    WAI_SENDING: 'Sending (WAI)',
    WAI_SUCCESSFULLY: 'Successfully (WAI)'
  },
  HistoryFilterLoanTypeEnum: [
    { value: 10000, text: 'Loan Log', code: 'LOAN_LOG' },
    { value: 10001, text: 'Document Log', code: 'DOCUMENT_LOG' },
    { value: 10002, text: 'Note Log', code: 'NOTE_LOG' },
    { value: 10003, text: 'Operation Log', code: 'OPERATION_LOG' },
    { value: 10004, text: 'Payment Log', code: 'PAYMENT_LOG' },
    { value: 10005, text: 'Maintenance Log', code: 'MAINTENANCE_LOG' },
    { value: 10006, text: 'Transaction Log', code: 'TRANSACTION_LOG' },
    { value: 10007, text: 'Collection Log', code: 'COLLECTION_LOG' }
  ],
  LoanTagsEnum: {
    BANK_STATEMENT: { value: 1 << 0, text: 'bank statement' },
    DL: { value: 1 << 1, text: 'dl' },
    SP_PO_WITHOUT_COLLECTION: { value: 1 << 2, text: 'same portfolio paid off without collection' },
    SP_PO_COLLECTION: { value: 1 << 3, text: 'same portfolio paid off with collection' },
    SP_CLOSE: { value: 1 << 4, text: 'same portfolio close' },
    DP_GOOD: { value: 1 << 5, text: 'different portfolio good status' },
    DP_PO_WITHOUT_COLLECTION: { value: 1 << 6, text: 'different portfolio without collection' },
    DP_PO_COLLECTION: { value: 1 << 7, text: 'different portfolio with collection' },
    DP_GOOD_RATIO: { value: 1 << 8, text: 'different portfolio good ratio paid off with collection' },
    DP_CLOSE: { value: 1 << 9, text: 'different portfolio close' },
    DP_ELSE: { value: 1 << 10, text: 'different portfolio else' },
    TB_SIGN_MARKETING: { value: 1 << 11, text: 'to be sign marketing' },
    TB_SUBMIT_MARKETING: { value: 1 << 12, text: 'to be submit marketing' },
    PAID_OF_MARKETING: { value: 1 << 13, text: 'paid off marketing' },
    POSITIVE_WITHDRAW_MARKETING: { value: 1 << 14, text: 'positive withdraw marketing' },
    ROCKET_CREDIT: { value: 1 << 15, text: 'rocket credit' },
    SP_GOOD_REJECT: { value: 1 << 16, text: 'same portfolio good status reject' },
    SP_PO_COLLECTION_REJECT: { value: 1 << 17, text: 'same portfolio with collection reject' },
    SP_ELSE_REJECT: { value: 1 << 18, text: 'same portfolio else reject' },
    WAKE_UP: { value: 1 << 19, text: 'wake up' },
    COMPRESS_SIGNATURE_LINK: { value: 1 << 21, text: 'compress signature link' }
  },
  ActionConst: {
    ADD: 'ADD',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    EXPORT: 'EXPORT',
    IMPORT: 'IMPORT'
  },
  SystemRegionEnum: {
    PANDA: { value: 1, text: 'PANDA' },
    VERTICAL: { value: 2, text: 'VERTICAL' },
    EPIC: { value: 3, text: 'EPIC' },
    OTHERS: { value: 4, text: 'OTHERS' }
  },
  ComplaintType: [
    { value: 1, text: 'Applied for a loan, but didn\'t receive money' },
    { value: 2, text: 'Attempts to collect debt not owed' },
    { value: 3, text: 'Can’t stop withdrawals from acct' },
    { value: 4, text: 'Cannot contact lender' },
    { value: 5, text: 'Charged fees or interest I didn\'t expect' },
    { value: 6, text: 'Contacts repeatedly or continuously/told to stop' },
    { value: 7, text: 'Customer Service Rep/Collection Rep' },
    { value: 8, text: 'Getting the loan' },
    { value: 9, text: 'Lender charged my bank account on wrong day or wrong amount' },
    { value: 10, text: 'Problem when making payment or with payoff' },
    { value: 11, text: 'Problem with add-on/Wage Assignment' },
    { value: 12, text: 'Problem with Credit Report' },
    { value: 13, text: 'Received loan did not apply for - Fraud' },
    { value: 14, text: 'Struggling to Pay Loan/unable to pay' },
    { value: 15, text: 'Took or threatened to take negative or legal action' },
    { value: 16, text: 'Other' }
  ],
  ComplaintSource: [
    { value: 1, text: 'Organic' },
    { value: 2, text: 'Verified' },
    { value: 3, text: 'Invited' },
    { value: 4, text: 'Redirected' }
  ],
  IBVSelectContactType: {
    SEND_BY_EMAIL: { value: 0, text: 'Send by Email' },
    SEND_BY_SMS: { value: 1, text: 'Send by SMS' }
  },
  SpecialConsiderationNote: [
    { value: 1, text: 'Open Loan-External' },
    { value: 2, text: 'Open Loan-Internal' },
    { value: 3, text: 'State' },
    { value: 4, text: 'ABA' },
    { value: 5, text: 'Weekly 2 DDs' },
    { value: 6, text: 'VOE' },
    { value: 7, text: 'Correction Override' },
    { value: 8, text: '2 Strong Exceptions' },
    { value: 9, text: 'CLR' },
    { value: 10, text: 'Collections(internal)' },
    { value: 11, text: 'PF or Employer change' },
    { value: 12, text: 'Inconsistent PF due to holiday' },
    { value: 13, text: 'Merchant Verification' },
    { value: 14, text: 'Other(Free Text)' }
  ],
  FraudFlag: {
    SUSPECTED: { value: 1, text: 'Suspected Identical IBV' },
    MISMATCHED_IBV: { value: 2, text: 'Suspected Mismatched IBV' },
    RELEASED: { value: -1, text: 'Released Identical IBV' }
  },
  SignatureSource: {
    COMPRESSED_LINK: { value: 1, text: 'Compressed Link' },
    MARKETING: { value: 2, text: 'Marketing' }
  },
  MarketingEmail: {
    PAID_OFF_MARKETING: { value: 1, text: 'Paid Off Marketing' },
    TO_BE_SIGNED_MARKETING: { value: 2, text: 'To Be Signed Marketing' }
  },
  AgentVerificationResult: [
    { value: 1, text: 'NOT MLA' },
    { value: -1, text: 'MLA' }
  ],
  SystemVerificationResult: [
    { value: 1, text: 'NOT MLA' },
    { value: -1, text: 'MLA' }
  ],
  ToBeConfirmQueueFlag: {
    UnknownCreditStatus: { value: 0, text: 'UnknownCreditStatus' },
    SuspectedMLA: { value: 1, text: 'SuspectedMLA' }
  },
  SettlementTypeEnum: {
    AutomaticSettlement: { value: 0, text: 'Automatic Settlement' },
    ManualSettlement: { value: 1, text: 'Manual Settlement' }
  },
  LitigantTypeEnum: {
    UNKNOWN: { value: 0, text: 'Unknown' },
    LITIGANT: { value: -1, text: 'Litigant' },
    NO_LITIGANT: { value: 1, text: 'No Litigant' }
  },
  IbvUpdateType: {
    CREATE_REQUEST_CODE: { value: 1, text: 'Create Request Code' },
    GET_REQUEST_STATUS: { value: 2, text: 'Get Request Status' },
    GET_MULTIPLE_REPORT: { value: 3, text: 'Get Multiple Report' }
  },
  IBVProviderType: {
    DECISION_LOGIC: { value: 10000, text: 'Decision Logic' },
    CHIRP: { value: 20000, text: 'Chirp' }
  },
  ILVStatusEnum: {
    ONLINE: { value: 1, text: 'online' },
    OFF_LINE: { value: -1, text: 'offline' }
  },
  SystemNameEnum: {
    PANDA3: 'PANDA3'
  },
  LanguageConst: [
    { value: 100, text: 'All', code: 'ALL' },
    { value: 101, text: 'English Only', code: 'GB' },
    { value: 102, text: 'Spanish Only', code: 'ES' }
  ],
  LegacyReasons: [
    { value: 10003, text: ['Auto withdrawn', 'Customer Data Incompatible', 'Unable to complete correction, customer is unreachable for more than 2 days'] },
    { value: 20005, text: ['Bad Employment/Position', 'Customer is self-employed'] },
    { value: 20000, text: ['Account closed', 'Bad Bank/Bad ABA', 'Customer has holds, freezes, restrictions, stop payments or TCA in the last 90 days', 'Customer is not the bk acct holder'] },
    { value: 10008, text: ['Customer is Unemployed', 'Denied by Tribe-Elevated concern', 'Denied by Tribe-General guidelines', 'NED', 'Not qualified as per loan matrix', 'Tribe Denied'] },
    { value: 10028, text: ['Customer has open loan with another CO'] },
    { value: 10007, text: ['Customer has liquid,savings or business account', 'Customer has no DDs', 'Non-Standard Source of Income', 'Prepaid card / Debit card', 'Unpredictable/Incorrect Payroll Frequency (Monthly, Daily, Semi-monthly, Weekend)'] },
    { value: 10026, text: ['Bad Contact Info'] },
    { value: 10006, text: ['Customer does not meet the minimum required age'] },
    { value: 20003, text: ['Customer is in collections', 'Customer is in Collections - No Call Attempt made', 'Customer is in External Collections', 'Customer is in Portfolio Collections'] },
    { value: 20006, text: ['Customer has Garnishment'] },
    { value: 20016, text: ['No Business State'] },
    { value: 10024, text: ['Duplicate lead'] },
    { value: 10023, text: ['Customer no longer interested - Already got another loan', 'Customer no longer interested - Amount too low', 'Customer no longer interested - Does not agree with the repayment schedule', 'Customer no longer interested - Does not want to complete loan process', 'Customer no longer interested - High Interest or APR', 'Customer no longer interested - Needs the funds sooner', 'Customer no longer interested - Payments too high', 'Customer requested not to be called again (DNC)'] },
    { value: 20015, text: ['Customer failed to answer the authentication/security questions', 'Customer is deceased', 'Data Incompatable with System', 'Incorrect Social Security Number', 'FRAUD'] },
    { value: 20014, text: ['Covered Borrower', 'Special Case'] },
    { value: 20023, text: ['Unable to do VOB or VOE (Verification of employment)'] },
    { value: 20026, text: ['No legacy reasons to display'] }

  ]
}

export default DataType
